import React, { useCallback, useEffect, useLayoutEffect, useRef, useState } from "react";
import { flushSync } from "react-dom";
import ReactLeafletGoogleLayer from "react-leaflet-google-layer";
import {
  MapContainer,
  Marker,
  FeatureGroup,
  Polygon,
  Tooltip,
  Polyline,
  TileLayer,
} from "react-leaflet";
import L from "leaflet";
import { EditControl } from "react-leaflet-draw";
import asset from "json/assets";
import eventEmitter from "services/event.emitter";
import events from "json/events";
import { booleanPointInPolygon } from "@turf/turf";
import * as _ from "underscore";
import { useMapEvents } from "react-leaflet";

import {
  AzureMapAPIKey,
  BingMapAPIKey,
  CourseGPSVectorMapUpdateValues,
  GoogleMapAPIKey,
  HoleElements,
  continuousHoleFeatures,
  courseMapElementLimit,
  defaultCouseMapElementColor,
  drawEventType,
  drawShapeType,
  leafletCustomIcon,
  singleCourseElements,
  singlePointLayers,
} from "json/constants";
import {
  LatLngStringtoLatLngArray,
  collectInvalidShapes,
  convertCourseMapData,
  convertCoursePolygonDataToString,
  convertLatLngStringToLngLatString,
  convertPolygonDataToString,
  convertSingleLatLngStringtoFloatArray,
  convertToLabelName,
  convertToLabelWithAttributesDesc,
  convertToLabelWithAttributesSize,
  convertToLabelWithAttributesType,
  convertToLatLngArrayOfObject,
  createVisibleCourseItemList,
  decryptSecretKey,
  findClosestIndex,
  getCourseMapBoundsAndElementWisePoints,
  getModalProperties,
  getPopUpTitle,
  hasSelfIntersection,
  hasShiftedPlaceholderCoordinates,
  holeElementsName,
  isColor,
  preparePointsToLatLong,
  pushMany,
  toTuple,
  generateBackgroundFromPerimeters,
  findNearestDistanceToPerimeters,
} from "services/utils";

import { useDispatch } from "react-redux";
import { removeAllMapData, resetShapeProperties } from "redux/MapSlice";
import { useMapControls } from "hooks/useMapBasicControls";
import { useEventEmitter } from "hooks/useEventEmitter";
import { useEscKeyPress } from "hooks/useEscKeyPress";
import { useRefHook } from "hooks/useRefHook";
import "leaflet/dist/leaflet.css";
import { BingLayer } from "react-leaflet-bing-v2";
import useNotiStack from "hooks/useNotistack";
import {
  useCourseMapData,
  useCourseGPSMappingData,
  useEditableCourseItem,
  useVisibleCourseElements,
  // useEditableHazardItem,
  useSelectedCourseZoneType,
  useCourseGPSNameList,
  useCourseShapePropertiesType,
  useCourseShapePropertiesSize,
  useIsDrawingStatus,
  useVisibleFacilityElements,
  useCourseShapePropertiesDesc,
  useGoogleAddress,
  useIsMoveModeEnabled,
  useCoursePolygonPropertiesType,
  useCoursePolygonPropertiesDesc,
  useCourseBridgePropertiesDesc,
  useCourseShapeBackgroundType,
  useCourseMarkerTreeDesc,
  useCourseMarkerTreeSize,
  useCourseMarkerTreeType,
  useCourseCliffDescType,
  useCourseCliffType,
  useCourseFixtureMarkerType,
  useCourseFixtureMarkerSize,
  useCourseNativeAreaDesc,
  useCourseNativeAreaType,
  useCourseNativeAreaSize,
  // useMarkerPointToBlink,
  useCourseHoleNumber,
  useCourseForestPolygonType,
  useMarkerPointToBlink,
  useMarkerLocationpoint,
  useCourseShapeBackgroundDesc,
  useCourseCreekSize,
  useCourseLavaType,
  useCourseResidenceDesc,
  useCourseResidenceType,
  useCourseResidenceSize,
  useCourseBuildingDesc,
  useCourseBuildingType,
  useCourseBuildingSize,
  useCourseParkingLotDesc,
  useCourseStreetDesc,
  useCourseStreetSize,
  useCourseFenceDesc,
  useCourseFenceSize,
  useCourseWaterDesc,
  useCourseWaterType,
  useCourseWaterSize,
  useCoursePathDesc,
  useCourseClubhouseDesc,
  useCourseClubhouseType,
  useCourseClubhouseSize,
} from "hooks/CourseMapDetails";
import {
  clearEditableCourseItem,
  clearCourseMapDetails,
  setEditableCourseItem,
  setVisibleCourseElements,
  updateCourseMapData,
  course_gps_vector_map_update,
  updateCourseMappingData,
  course_mapping_gps_update,
  clearSelectedCourseZoneType,
  clearCourseShapePropertiesType,
  course_gps_vector_map_create,
  setIsDrawingStatus,
  setVisibleFacilityElements,
  clearCourseShapePropertiesSize,
  updateClubHouseCenter,
  clearCourseShapePropertiesDesc,
  setTransformedCourseData,
  setTransformedHoleData,
  setMovableMapElement,
  setEnableMoveMode,
  course_map_gps_vector_details,
  setfilteredCourseHoleData,
  setSelectedCourseZoneType,
} from "redux/CourseMapSlice";
import * as turf from '@turf/turf';
import {
  clearCourseDetailsData,
  setSearchedCourseName,
} from "redux/CourseSlice";
import { useAssociatedCourseData } from "hooks/RangeDetails";
import CustomCoursePopOver from "components/CustomCoursePopOver/CustomCoursePopOver";
import { useProfileUsername } from "hooks/ProfileDetails";
import { useSearchParams } from "react-router-dom";
import MapControlList from "components/MapControlList/MapControlList";
import { useMovableMapElement } from "hooks/useMovableMapElement";
import { CourseMapInfoPopOver } from "components/CourseMapInfoPopOver/CourseMapInfoPopOver";
import CourseScoreCardPopOver from "components/CourseScoreCardPopOver/CourseScoreCardPopOver";
import CourseMappingNoteList from "components/CourseMappingNoteList/CourseMappingNoteList";
import DraggableCoursePopOver from "components/DraggableCoursePopOver/DraggableCoursePopOver";
import AzureStaticOverlay from "./AzureMapsStaticOverlay/AzureMapsStaticOverlay";
import ImageOverlayPanel from "components/CourseMap/ImageOverlayTool/ImageOverlayPanel";
import ToolsMenu from "components/CourseMap/ToolsMenu/ToolsMenu";
import useImageOverlays from "components/CourseMap/ImageOverlayTool/useImageOverlays";
import ImageOverlayLayer from "components/CourseMap/ImageOverlayTool/ImageOverlayLayer";
import useFullCourseShift from "components/CourseMap/FullCourseShiftTool/useFullCourseShift";
import CourseShiftLayer from "components/CourseMap/FullCourseShiftTool/CourseShiftLayer";
import CourseShiftPanel from "components/CourseMap/FullCourseShiftTool/CourseShiftPanel";
import { collectSelection } from "./DeleteBySelectionTool/selectionDelete";
import SelectionHighlightLayer from "./DeleteBySelectionTool/SelectionHighlightLayer";
import ModalWrapper from "layout/ModalWrapper/ModalWrapper";
import NoificationModal from "pages/ModalPage/NoificationModal";

delete L.Icon.Default.prototype._getIconUrl; //deleting default icon given by react leaflet draw.

const EDIT_CONTROL_EDIT_OPTIONS = {
  poly: {
    allowIntersection: false,
  },
};

const EDIT_CONTROL_DRAW_OPTIONS = {
  polygon: {
    feet: false,
    metric: false,
    allowIntersection: false,
  },
  polyline: {
    feet: false,
    metric: false,
  },
  rectangle: {
    showArea: false,
    shapeOptions: {
      color: "#133E84",
      weight: 2,
      dashArray: "6 6",
      fillOpacity: 0.05,
    },
  },
};

const CourseMap = () => {
  const bunkerPolygonType = useCoursePolygonPropertiesType()
  const bunkerPolygonDesc = useCoursePolygonPropertiesDesc()
  const bridgePropertiesDesc = useCourseBridgePropertiesDesc()
  const backgroundShapeType = useCourseShapeBackgroundType()
  const backgroundShapeDesc =useCourseShapeBackgroundDesc()
  const cliffPropertiesDesc = useCourseCliffDescType()
  const cliffPropertiesType = useCourseCliffType()
  const nativeAreaPropertiesDesc = useCourseNativeAreaDesc()
  const nativeAreaPropertiesType = useCourseNativeAreaType()
  const nativeAreaPropertiesSize = useCourseNativeAreaSize()
  const fixturePropertiesType = useCourseFixtureMarkerType()
  const fixturePropertiesSize = useCourseFixtureMarkerSize()
  const forestPolygonType = useCourseForestPolygonType()
  const creekSizeRedux = useCourseCreekSize()
  const lavaTypeRedux = useCourseLavaType()
  const residenceDescRedux = useCourseResidenceDesc()
  const residenceTypeRedux = useCourseResidenceType()
  const residenceSizeRedux = useCourseResidenceSize()
  const buildingDescRedux = useCourseBuildingDesc()
  const buildingTypeRedux = useCourseBuildingType()
  const buildingSizeRedux = useCourseBuildingSize()
  const parkingLotDescRedux = useCourseParkingLotDesc()
  const streetDescRedux = useCourseStreetDesc()
  const streetSizeRedux = useCourseStreetSize()
  const fenceDescRedux = useCourseFenceDesc()
  const fenceSizeRedux = useCourseFenceSize()
  const waterDescRedux = useCourseWaterDesc()
  const waterTypeRedux = useCourseWaterType()
  const waterSizeRedux = useCourseWaterSize()
  const pathDescRedux = useCoursePathDesc()
  const clubhouseDescRedux = useCourseClubhouseDesc()
  const clubhouseTypeRedux = useCourseClubhouseType()
  const clubhouseSizeRedux = useCourseClubhouseSize()


  React.useEffect(() => {
    //setting default marker
    L.Icon.Default.mergeOptions({
      iconRetinaUrl: require("leaflet/dist/images/marker-icon-2x.png"),
      iconUrl: require("leaflet/dist/images/marker-icon.png"),
      shadowUrl: require("leaflet/dist/images/marker-shadow.png"),
    });
  }, []);

  React.useEffect(() => {
    //-----leaflet uses polyline to create polygons; other shapes do not have a error object! (._.')

    //error tooltip..............
    L.drawLocal.draw.handlers.polyline.error =
      "<strong>Oops!</strong> You cannot draw a shape like that!";

    //custom tooltip messages --------------   console.log(' L.drawLocal', L.drawLocal);
    L.drawLocal.draw.handlers.polygon.tooltip = {
      start: "Click to start drawing shape<br/> or press Esc key to cancel",
      cont: "Click to continue drawing shape<br/> or press Esc key to cancel",
      end: "Click first point to close this shape<br/> or press Esc key to cancel",
    };
    L.drawLocal.draw.handlers.polyline.tooltip = {
      start: "Click to start drawing line <br/> or press Esc key to cancel",
      cont: "Click to continue drawing line<br/> or press Esc key to cancel",
      end: "Click last point to finish line<br/> or press Esc key to cancel",
    };

    L.drawLocal.draw.handlers.marker.tooltip = {
      start: "Click map to place marker.<br/> Or press Esc key to cancel",
    };

    L.drawLocal.edit.handlers.edit.tooltip.subtext =
      "Drag vertices or markers to edit shapes.";
    L.drawLocal.edit.handlers.edit.tooltip.text =
      " Click outside of the shape to save or cancel.";
    // L.drawLocal.edit.handlers.edit.tooltip.subtext =
    //   " Press Esc key to undo changes.";
    //
    //   " Drag vetices or markers to edit shapes.";
  }, []);

  const dispatch = useDispatch();
  const [searchParams] = useSearchParams();
  const id_courseFromQuery = searchParams.get("course");
  const { toastError, toastSuccess, toastWarning, toastInfo } = useNotiStack();
  const modalProperties = getModalProperties();
  const secret_Key = decryptSecretKey();
  const username = useProfileUsername();
  const associatedCourseData = useAssociatedCourseData();
  const selectedZoneType = useSelectedCourseZoneType();
  const selectedZoneTypeRef = useRefHook(selectedZoneType);
  const courseMapData = useCourseMapData();
  const courseGPSMapping = useCourseGPSMappingData();
  const courseGPSMappingData = courseGPSMapping?.GPSList;
  const courseGPSMappingDataRef = useRefHook(courseGPSMapping?.GPSList);
  const courseMapDataRef = useRefHook(courseMapData);
  const courseMapDataLatestRef = useRef(courseMapData);
  courseMapDataLatestRef.current = courseMapData;
  
   const selectedHoleNo = useCourseHoleNumber()

   const markerBlinkOpacity = useMarkerPointToBlink()
   const markerLocation = useMarkerLocationpoint()
   const compareCoordinates = (coordsA, coordsB) => {
    return coordsA[0] === coordsB[0] && coordsA[1] === coordsB[1];
  };

  const clubhousecenterCoords = {
    clubLat: courseGPSMapping.clubLat,
    clubLon: courseGPSMapping.clubLon,
  };

  const editableArea = useEditableCourseItem();

  const editableAreaRef = useRefHook(editableArea);

  const shapePropType = useCourseShapePropertiesType();
  const shapePropSize = useCourseShapePropertiesSize();
  const shapePropDesc = useCourseShapePropertiesDesc();
  const markerTreeDesc = useCourseMarkerTreeDesc()
  const markerTreeSize = useCourseMarkerTreeSize()
  const markerTreeType = useCourseMarkerTreeType()

  const googleLocation = useGoogleAddress();
  const MAX_ZOOM = 22;
  const MIN_ZOOM = 15;
  const SCALE_DASH = [10, 5];
  const mapRef = useRef();
  const editControlRef = useRef();
  const featureGroupRef = useRef(null);
  const lastFitRef = useRef({ hole: null, hash: null });
  const [isGoogleView, setIsGoogleView] = useState(true);
  const [centralPathLine, setCentralPathLine] = useState();
  const justCreatedCentralPathRef = useRef(false);

  const {
    zoomIn,
    zoomOut,
    drawPolyLine,
    drawPolygon,
    drawPoint,
    disableDraw,
    flyTo,
    drawRectangle,
  } = useMapControls(mapRef, editControlRef, isGoogleView);
  const imageOverlayTool = useImageOverlays(mapRef);
  const fullCourseShift = useFullCourseShift();
  const shiftReloadPendingRef = useRef(false);
  const shiftedPlaceholderWarnedRef = useRef(false);

  const visibleCourseElements = useVisibleCourseElements();
  const isDrawing = useIsDrawingStatus();
  const [boundLatLng, setBoundLatLng] = useState(null);
  const [currentLocation, setCurrentLocation] = useState(null);

  const [mapControlList, setMapControlList] = useState([]);
  const [editPolygonData, setEditPolygonData] = useState(null);
  const [editMarkerData, setEditMarkerData] = useState(null);
  const [movableShapeData, setMovableShapeData] = useState(null);

  const [addedLayer, setAddedLayer] = useState([]);
  const [scaleLineData, setScaleLineData] = useState([]);
  const [addedPoints, setAddedPoints] = useState([]); // TODO: multiple add

  const [clubHouseCenterData, setClubHouseCenterData] = useState({});
  const [courseWiseData, setCourseWiseData] = useState([]);
  const [holeWiseData, setHoleWiseData] = useState([]);
  const [hazardData, setHazardData] = useState([]);
  const [fcbData, setFcbData] = useState([]);
  const [teeCenterData, setTeeCenterData] = useState([]);
  const [autoTeeCenterCoords, setAutoTeeCenterCoords] = useState();
  const [mapDomEl, setMapDomEl] = useState();
  const [isScaleDrawEnabled, setIsScaleDrawEnabled] = useState(false);
  const [isSelectionDeleteEnabled, setIsSelectionDeleteEnabled] = useState(false);
  const isSelectionDeleteEnabledRef = useRef(false);
  const [selectionCandidates, setSelectionCandidates] = useState(null);
  const teeCenterDataRef = useRef([]);
  teeCenterDataRef.current = teeCenterData;
  const selectedHoleNoRef = useRef(null);
  selectedHoleNoRef.current = selectedHoleNo;
  const [autoFrontPoints, setAutoFrontPoints] = useState()
  const [autoCenterFCBPoints, setAutoCenterFCBPoints] = useState()
  const [tileError, setTileError] = useState(false);
  const [isMapControlListPanelHidden, setMapControlListPanelHidden] = useState(false);
  const autoGenExistingBgRef = useRef(null);


  const isScaleDrawEnabledRef = useRefHook(isScaleDrawEnabled);
  const lastZoomHoleRef = useRef(null);
  const holeWiseDataRef = useRefHook(holeWiseData);
  const courseWiseDataRef = useRefHook(courseWiseData);

  const [autoGenPreview, setAutoGenPreview] = useState(null);
  const [distanceGuide, setDistanceGuide] = useState(null);
  const distanceGuideActiveRef = useRef(false);
  const skipNextAttributeOnlySaveRef = useRef(false);
  const hydratedPropertiesChangeIdRef = useRef(null);
  const cleanedInvalidIdsRef = useRef(new Set());
  const cleanupInFlightIdsRef = useRef(new Set());

  const [isToolsMenuOpen, setIsToolsMenuOpen] = useState(false);
  useEventEmitter(events.toolsMenuVisibility, (e) => {
    setIsToolsMenuOpen(Boolean(e?.visible));
  });

  useEffect(() => {
    dispatch(setfilteredCourseHoleData(holeWiseDataRef.current))
  }, [holeWiseData]);

  useEffect(() => {
    if (!Number.isFinite(selectedHoleNo) || selectedHoleNo <= 0) return;
    if (lastZoomHoleRef.current === selectedHoleNo) return;
    lastZoomHoleRef.current = selectedHoleNo;
    eventEmitter.emit(events.fitMapToHole, { holeNumber: selectedHoleNo, force: true });
  }, [selectedHoleNo]);

  const visibleFacilityElementList = useVisibleFacilityElements();

  const CourseGPSNameListResponse = useCourseGPSNameList();

  const emitDrawPolygon = () => {
    let z = selectedZoneTypeRef.current.type;
    if (z === "line") {
      z = "polyline";
    }

    eventEmitter.emit(events.draw, { event: "add", type: z });
  };
  const getActiveViewIcon = (shape) => {
    let holeItem = visibleCourseElements[shape?.hole - 1];

    if (holeItem) {
      if (holeItem[shape?.label]?.isElementVisible) {
        if (shape?.label === "Greencenter") {
          return false; // not showing Greencenter from map data instead using from coursGPSData
        }

        if (shape?.label === "Teeboxcenter") {
          if (holeItem[shape?.label]?.idList && shape?.teeboxID) {
            return holeItem[shape?.label]?.idList?.includes(shape?.teeboxID);
          }
        }
        if (shape?.label === "fcb") {
          if (holeItem[shape?.label]?.idList && shape?.id) {
            return holeItem[shape?.label]?.idList?.includes(shape?.id);
          }
        } else {
          if (holeItem[shape?.label]?.idList && shape?._id) {
            return holeItem[shape?.label]?.idList?.includes(shape?._id);
          }
        }
      }
      return false;
    }
  };

  const getActiveFacilityFeatureIcon = (data) => {

    const label = data?.label 
    === "PracticeGreen" ? "Practicegreen" : 
                     data?.label === "PracticeBunker" ? "Practicebunker" :
                  data?.label
    
    if (visibleFacilityElementList[`${label}`]?.isGroupVisible) {
      let _t = new Set(visibleFacilityElementList[`${label}`].idList);
      return _t.has(data?._id);
    } else {
      return false;
    }
  };

  const clearEditableModeVariables = () => {
    dispatch(clearEditableCourseItem());
    dispatch(clearCourseShapePropertiesType());
    dispatch(clearCourseShapePropertiesSize());
    dispatch(clearCourseShapePropertiesDesc());
  };

  const checkisInsidePerimeter = useCallback(
    (e, holeNumber, type) => {
      let tempAllPolyData = holeWiseDataRef.current;
      const allowedPolygon = tempAllPolyData?.find(
        (s) => s.label === "Perimeter" && s.hole === holeNumber
      )?.list;
      let isInsideAllowedPolygon = [];
      if (!allowedPolygon) {
        //for driving ranges that do not have perimeters ~ may be removed later
        return true;
      } else {
        // for edit mode
        if (type === "edit") {
          let source = Object.values(e?.layers?._layers)[0];
          if (source?.hasOwnProperty("_latlngs")) {
            //   //polyline=>latlngs[]
            //   //polygon=>latlngs[[]]
            let converted = [];
            if (Array.isArray(source?._latlngs[0])) {
              // polygon
              let a = convertPolygonDataToString(source?._latlngs[0].flat());
              converted = preparePointsToLatLong(a)?.flat();
            } else {
              //polyline
              let a = convertPolygonDataToString(source?._latlngs);
              converted = preparePointsToLatLong(a)?.flat();
            }

            for (const coord of converted) {
              isInsideAllowedPolygon.push(
                booleanPointInPolygon(coord, {
                  type: "Polygon",
                  coordinates: allowedPolygon,
                })
              );
            }
          } else if (source?.hasOwnProperty("_latlng")) {
            //marker
            //marker=> latlng {}
            let a = convertPolygonDataToString(source?._latlng);
            let converted = preparePointsToLatLong(a).flat();
            isInsideAllowedPolygon.push(
              booleanPointInPolygon([...converted].flat(), {
                type: "Polygon",
                coordinates: allowedPolygon,
              })
            );
          }
        } else {
          // for create mode
          const drawnShape = e.layer.toGeoJSON();
          if (drawnShape.geometry.type === "Point") {
            const formattedDrawnPoint = [
              drawnShape.geometry.coordinates[1],
              drawnShape.geometry.coordinates[0],
            ];
            // Check if the point's coordinates are within the allowed polygon
            isInsideAllowedPolygon.push(
              booleanPointInPolygon(formattedDrawnPoint, {
                type: "Polygon",
                coordinates: allowedPolygon,
              })
            );
          } else if (drawnShape.geometry.type === "LineString") {
            const polylineCoordinates = drawnShape.geometry.coordinates;

            for (const coord of polylineCoordinates) {
              const formattedDrawnPoint = [coord[1], coord[0]];
              isInsideAllowedPolygon.push(
                booleanPointInPolygon(formattedDrawnPoint, {
                  type: "Polygon",
                  coordinates: allowedPolygon,
                })
              );
            }
          } else if (drawnShape.geometry.type === "Polygon") {
            const polygonCoordinates = drawnShape.geometry.coordinates[0];
            for (const coord of polygonCoordinates) {
              const formattedDrawnPoint = [coord[1], coord[0]];
              isInsideAllowedPolygon.push(
                booleanPointInPolygon(formattedDrawnPoint, {
                  type: "Polygon",
                  coordinates: allowedPolygon,
                })
              );
            }
          }
        }
      }

      // return true;
      return !isInsideAllowedPolygon.includes(false);
    },
    [holeWiseData]
  );
  const checkIsInsideBackground = (e, type) => {
    let tempBackGroundData = courseWiseDataRef.current;
    const allowedPolygon = tempBackGroundData?.find(
      (s) => s.label === "Background"
    )?.list;
    let isInsideBackGround = [];

    if (!allowedPolygon) {
      //for driving ranges that do not have perimeters ~ may be removed later
      return true;
    } else {
      // for edit mode
      if (type === "edit") {
        let source = Object.values(e?.layers?._layers)[0];
        if (source?.hasOwnProperty("_latlngs")) {
          //   //polyline=>latlngs[]
          //   //polygon=>latlngs[[]]
          let converted = [];
          if (Array.isArray(source?._latlngs[0])) {
            // polygon
            let a = convertPolygonDataToString(source?._latlngs[0].flat());
            converted = preparePointsToLatLong(a)?.flat();
          } else {
            //polyline
            let a = convertPolygonDataToString(source?._latlngs);
            converted = preparePointsToLatLong(a)?.flat();
          }

          for (const coord of converted) {
            isInsideBackGround.push(
              booleanPointInPolygon(coord, {
                type: "Polygon",
                coordinates: allowedPolygon,
              })
            );
          }
        } else if (source?.hasOwnProperty("_latlng")) {
          //marker
          //marker=> latlng {}
          let a = convertPolygonDataToString(source?._latlng);
          let converted = preparePointsToLatLong(a).flat();
          isInsideBackGround.push(
            booleanPointInPolygon([...converted].flat(), {
              type: "Polygon",
              coordinates: allowedPolygon,
            })
          );
        }
      } else {
        // for create mode
        const drawnShape = e.layer.toGeoJSON();
        if (drawnShape.geometry.type === "Point") {
          const formattedDrawnPoint = [
            drawnShape.geometry.coordinates[1],
            drawnShape.geometry.coordinates[0],
          ];
          // Check if the point's coordinates are within the allowed polygon
          isInsideBackGround.push(
            booleanPointInPolygon(formattedDrawnPoint, {
              type: "Polygon",
              coordinates: allowedPolygon,
            })
          );
        } else if (drawnShape.geometry.type === "LineString") {
          const polylineCoordinates = drawnShape.geometry.coordinates;

          for (const coord of polylineCoordinates) {
            const formattedDrawnPoint = [coord[1], coord[0]];
            isInsideBackGround.push(
              booleanPointInPolygon(formattedDrawnPoint, {
                type: "Polygon",
                coordinates: allowedPolygon,
              })
            );
          }
        } else if (drawnShape.geometry.type === "Polygon") {
          const polygonCoordinates = drawnShape.geometry.coordinates[0];
          for (const coord of polygonCoordinates) {
            const formattedDrawnPoint = [coord[1], coord[0]];
            isInsideBackGround.push(
              booleanPointInPolygon(formattedDrawnPoint, {
                type: "Polygon",
                coordinates: allowedPolygon,
              })
            );
          }
        }
      }
    }
    // return true;
    return !isInsideBackGround.includes(false);
  };

  const _onCreated = (e) => {
    if (isScaleDrawEnabledRef?.current) {
      let scaleData;
      if (e.layerType === "polyline") {
        scaleData = convertPolygonDataToString(e.layer.getLatLngs()); //returns array
      }
      setScaleLineData(preparePointsToLatLong(scaleData));
      removeSelectedLayer(e?.layer);
      return;
    }

    if (isSelectionDeleteEnabledRef.current) {
      if (e.layerType === "rectangle") {
        const selectionBounds = e.layer.getBounds();
        removeSelectedLayer(e?.layer);
        const result = collectSelection({
          bounds: selectionBounds,
          courseWiseData: courseWiseDataRef.current,
          holeWiseData: holeWiseDataRef.current,
          teeCenterData: teeCenterDataRef.current,
          selectedHoleNo: selectedHoleNoRef.current,
        });
        const totalSelected =
          result.vectorShapes.length + result.teeCenters.length;
        if (totalSelected === 0) {
          const currentHoleNo = Number(selectedHoleNoRef.current);
          const hasHoleSelected =
            Number.isFinite(currentHoleNo) && currentHoleNo > 0;
          if (result.excludedByHole > 0 && !hasHoleSelected) {
            toastInfo(
              "Hole elements (teeboxes, bunkers, tee centers) can be deleted only for the selected hole. Select the hole in Hole Features and try again."
            );
          } else if (result.excludedByHole > 0) {
            toastInfo(
              `The selection contains only elements of other holes. Hole ${currentHoleNo} is currently selected — switch the hole in Hole Features and try again.`
            );
          } else {
            toastInfo("No deletable objects are fully inside the selection.");
          }
          drawRectangle();
        } else {
          setSelectionCandidates(result);
        }
      } else {
        removeSelectedLayer(e?.layer);
      }
      return;
    }

    if (e.layerType === "rectangle") {
      removeSelectedLayer(e?.layer);
      return;
    }

    let ignoreShape = false;

    if (!checkIsInsideBackground(e, "create")) {
      ignoreShape = true;
      toastError("Drawn shape must be inside the Background.");
      featureGroupRef.current?.removeLayer(e.layer);
    } else if (
      !checkisInsidePerimeter(e, selectedZoneTypeRef.current?.hole, "create")
    ) {
      ignoreShape = true;
      toastError("Drawn shape must be inside the perimeter.");
      featureGroupRef.current?.removeLayer(e.layer);
    } else if (e.layerType === "polyline") {
      const pts = e.layer.getLatLngs();
      if (!pts || pts.length < 2) {
        ignoreShape = true;
        toastError("Line needs at least 2 points.");
        featureGroupRef.current?.removeLayer(e.layer);
      }
    } else if (e.layerType && !singlePointLayers.includes(e.layerType)) {
      const ring = e.layer.getLatLngs()?.[0];
      if (!ring || ring.length < 3) {
        ignoreShape = true;
        toastError("Polygon needs at least 3 points.");
        featureGroupRef.current?.removeLayer(e.layer);
      }
    }

    if (!ignoreShape) {
      if (!_.isEmpty(selectedZoneTypeRef.current)) {
        let data;
        if (e.layerType && singlePointLayers.includes(e.layerType)) {
          data = convertPolygonDataToString(e.layer.getLatLng()); // returns object
        } else if (e.layerType === "polyline") {
          let dataLine = convertPolygonDataToString(e.layer.getLatLngs()); //returns array
    
          const coordsArrayCentLine = dataLine.split(' ').map(coord => coord.split(',').map(Number));
          const line = turf.lineString(coordsArrayCentLine);
          setCentralPathLine(line)
          justCreatedCentralPathRef.current = true;
   
if(courseMapDataRef?.current?.Holes?.Hole[selectedZoneTypeRef.current?.hole -1]?.Green){
const centerFCBArray = [courseGPSMappingDataRef?.current[selectedZoneTypeRef.current?.hole -1]?.centerLat ,
courseGPSMappingDataRef?.current[selectedZoneTypeRef.current?.hole -1]?.centerLon
]
let lineArray = line.geometry.coordinates
const closestIndex = findClosestIndex(lineArray, centerFCBArray);
const indexValue = closestIndex 
const newLineArr = lineArray.slice(0, indexValue);
newLineArr.splice(indexValue, 0, centerFCBArray)
const newArray = newLineArr

// const newArray = [line.geometry.coordinates, centerFCBArray];
//  data = newArray?.map(coord => coord.join(',')).join(' ')
//  if(autoFrontPoints){
  data = newArray?.map(coord => coord.join(',')).join(' ')
//  }else{
// data = dataLine
  
//  }
}else {
data = dataLine
}

        } else {
          data = convertPolygonDataToString(e.layer.getLatLngs()[0]); // returns array of array
          if (selectedZoneTypeRef.current.element === "Teebox") {
            let test_polygon = L.polygon(e.layer.getLatLngs()[0]);
            let bounds = test_polygon.getBounds();
            var centerLatLng = {
              lat: (bounds._southWest.lat + bounds._northEast.lat) / 2,
              lng: (bounds._southWest.lng + bounds._northEast.lng) / 2,
            };
            setAutoTeeCenterCoords([centerLatLng.lat, centerLatLng.lng]);
          }
          else if(selectedZoneTypeRef.current.element === "Green"){
            let test_polygon = L.polygon(e.layer.getLatLngs()[0]);
            let bounds = test_polygon.getBounds();
            
            let centerLatLng = {
              lat: (bounds._southWest.lat + bounds._northEast.lat) / 2,
              lng: (bounds._southWest.lng + bounds._northEast.lng) / 2,
            };
            setAutoCenterFCBPoints([centerLatLng.lat, centerLatLng.lng])
          }
        }

        setAddedLayer((prevItems) => [...prevItems, e?.layer]);
           setAddedTreePoint([data])
        setAddedPoints((prevItems) => [...prevItems, data]);

        if(selectedZoneTypeRef.current.element !== "Tree"){
          eventEmitter.emit(events.addMarkerToggle, { visible: true });
        }
      }
    } else {

      if (
        !singleCourseElements?.includes(
          selectedZoneTypeRef.current?.element?.toLowerCase()
        ) &&
        continuousHoleFeatures?.includes(
          selectedZoneTypeRef.current?.element?.toLowerCase()
        )
      ) {
        emitDrawPolygon();
      } else {
        eventEmitter.emit(events.resetDrawingMode);
      }

      return;
    }
  };

  const _onEdited = useCallback(
    (e) => {
      let ignoreShape = false;
      let selectedHoleNumber = -1;
      selectedHoleNumber = editableAreaRef.current.hole
        ? editableAreaRef.current.hole
        : editableAreaRef.current.holeNumber;
      // // perimeter can be moved to expand or
      if (
        editableAreaRef.current.label !== "Background" &&
        !checkIsInsideBackground(e, "edit")
      ) {
        ignoreShape = true;
        toastError("Drawn shape must be inside the Background.");
      } else if (
        editableAreaRef.current.label !== "Perimeter" &&
        selectedHoleNumber !== -1 &&
        !checkisInsidePerimeter(e, selectedHoleNumber, "edit")
      ) {
        toastError("Drawn shape must be inside the perimeter.");
        // featureGroupRef.current?.removeLayer(e.layer);
        ignoreShape = true;
      }

      if (!ignoreShape) {
        let source = Object.values(e?.layers?._layers)[0];
        if (!source) {
          if (
            editableAreaRef.current?.label === "Tree" ||
            editableAreaRef.current?.label === "Rock"
          ) {
            skipNextAttributeOnlySaveRef.current = true;
            let prevCoordObject = {
              lat: editableAreaRef.current.list[0][0][0],
              lng: editableAreaRef.current.list[0][0][1],
            };
            setEditMarkerData(prevCoordObject);
          } else {
            skipNextAttributeOnlySaveRef.current = true;
            let coordinateList = editableAreaRef.current.list[0];
            let formattedLatLngList = [];
            coordinateList.forEach((item) => {
              formattedLatLngList.push({ lat: item[0], lng: item[1] });
            });
            setEditPolygonData(formattedLatLngList);
          }

          return;
        }

        if (source?.hasOwnProperty("_latlngs")) {
          const isPolygon = Array.isArray(source?._latlngs[0]);
          if (isPolygon) {
            const ring = source._latlngs[0];
            if (!ring || ring.length < 3) {
              toastError("Polygon needs at least 3 points.");
              clearEditableModeVariables();
              return;
            }
          } else {
            const pts = source._latlngs;
            if (!pts || pts.length < 2) {
              toastError("Line needs at least 2 points.");
              clearEditableModeVariables();
              return;
            }
          }

          skipNextAttributeOnlySaveRef.current = true;

          if (isPolygon) {
            setEditPolygonData(source?._latlngs[0].flat());
          } else {
            //polyline
            setEditPolygonData(source?.editing.latlngs.flat());
          }
        } else if (source?.hasOwnProperty("_latlng")) {
          //marker=> latlng {}
          skipNextAttributeOnlySaveRef.current = true;
          setEditMarkerData(source?._latlng);
          //marker
        }
      } else {
        clearEditableModeVariables();

        return;
      }
    },
    []
  );

  const updateCourseGPSVectorMap = (payload) => {
    dispatch(
      course_gps_vector_map_update({
        body: payload,
        user: {
          secretKey: secret_Key,
          userName: username,
        },
      })
    ).then((res) => {
      if (res?.payload?.data?.Status === 1) {
        setTimeout(() => {
          dispatch(
            course_map_gps_vector_details({
              body: {
                id_course: id_courseFromQuery,
              },
              user: {
                secretKey: secret_Key,
                userName: username,
              },
            })
          );
        }, 500);
      } else {
        toastError(`CourseGPSVectorMapUpdate failed (id_course: ${id_courseFromQuery}). Server response: ${JSON.stringify(res?.payload?.data)}`);
      }
    });
  };

  const updateCourseMappingGPSData = (payload) => {
    dispatch(
      course_mapping_gps_update({
        body: payload,
        user: {
          secretKey: secret_Key,
          userName: username,
        },
      })
    );
  };

  const handleCourseMarkerDataUpdate = () => {
    let temp_courseGPSMappingData = structuredClone(courseGPSMappingData);
    let payload;
    if (editableArea?.zone && editableArea.zone === "clubhousecenter") {
      dispatch(
        updateClubHouseCenter({
          clubLat: editMarkerData.lat,
          clubLon: editMarkerData.lng,
        })
      );
      payload = {
        id_course: parseInt(id_courseFromQuery),
        clubLat: editMarkerData?.lat,
        clubLon: editMarkerData.lng,
        id_courseLayout: 2,
        GPSList: temp_courseGPSMappingData,
      };
    } else {
      let teeNumber = editableArea?.id?.split("_")[1];
      if (editableArea?.type === "Teeboxcenter") {
        temp_courseGPSMappingData[editableArea.holeNumber - 1] = {
          ...temp_courseGPSMappingData[editableArea.holeNumber - 1],
          [`teeLat${teeNumber}`]: editMarkerData.lat,
          [`teeLon${teeNumber}`]: editMarkerData.lng,
        };
      }
      if (editableArea?.type === "hazard") {
        let GPSNameObject = CourseGPSNameListResponse.find(
          (s) => s.id === Number(shapePropType)
        );
        let customNameNumber = editableArea?.id?.split("_")[1];
        temp_courseGPSMappingData[editableArea.holeNumber - 1] = {
          ...temp_courseGPSMappingData[editableArea.holeNumber - 1],
          [`customLat${customNameNumber}`]: editMarkerData.lat,
          [`customLon${customNameNumber}`]: editMarkerData.lng,
          [`customDesc${customNameNumber}`]: GPSNameObject?.description,
          [`customName${customNameNumber}`]: GPSNameObject?.name,
          [`id_courseGPSName${customNameNumber}`]: GPSNameObject.id,
        };
      }
      if (editableArea?.type === "fcb") {
        temp_courseGPSMappingData[editableArea.holeNumber - 1] = {
          ...temp_courseGPSMappingData[editableArea.holeNumber - 1],
          [`${editableArea?.place}Lat`]: editMarkerData.lat,
          [`${editableArea?.place}Lon`]: editMarkerData.lng,
        };
      }

      dispatch(updateCourseMappingData(temp_courseGPSMappingData));
      payload = {
        id_course: parseInt(id_courseFromQuery),
        clubLat: courseGPSMapping?.clubLat,
        clubLon: courseGPSMapping?.clubLon,
        id_courseLayout: 2,
        GPSList: temp_courseGPSMappingData,
      };
    }

    updateCourseMappingGPSData(payload);
  };

  const handleFacilityDataUpdate = (editPolygonData, editableArea) => {

    const sourceCourseMapData = courseMapDataLatestRef.current ?? courseMapData;
    if (!sourceCourseMapData) return;
    let temp_courseMapData = structuredClone(sourceCourseMapData);
    let name = editableArea.label === "Nativearea" ? "NativeArea" : editableArea.label;
    let data;
    let payload;
    let pos = temp_courseMapData[`${name}`]?.Shapes?.Shape?.findIndex(
      (s) => s.id === editableArea?._id
    );
    if (editMarkerData) {
      // data = editMarkerData;
      temp_courseMapData[`${name}`].Shapes.Shape[
        pos
      ].Points = `${editMarkerData?.lng} ${editMarkerData?.lat} `;

      const curAttrs = temp_courseMapData[`${name}`].Shapes.Shape[pos]?.Attributes;
      if (curAttrs) {
        temp_courseMapData[`${name}`].Shapes.Shape[pos].Attributes = {
          ...curAttrs,
          Type: shapePropType ?? curAttrs.Type ?? editableArea?.Attributes?.Type,
          Size: shapePropSize ?? curAttrs.Size ?? editableArea?.Attributes?.Size,
        };
      }

      payload = {
        holeNumber: 0,
        id_courseGPSVector: editableArea?._id,
        name: editableArea?.label,
        points: editMarkerData,
        type: CourseGPSVectorMapUpdateValues[`${editableArea?.type}`],
      };
    } else if (editPolygonData) {
      data =
        typeof editPolygonData === "object"
          ? convertCoursePolygonDataToString(editPolygonData)
          : editPolygonData;
      temp_courseMapData[`${name}`].Shapes.Shape[pos].Points = data;
      if (editableArea?.label === "Background") {
        if (shapePropDesc || editableArea?.Attributes?.Description) {
          temp_courseMapData[`${name}`].Shapes.Shape[pos].Attributes[
            "Description"
          ] = shapePropDesc || editableArea?.Attributes?.Description;
        }
      }else if(editableArea?.label === "Sand") {
}else {
        const curAttrs = temp_courseMapData[`${name}`].Shapes.Shape[pos]?.Attributes;
        if (curAttrs) {
          temp_courseMapData[`${name}`].Shapes.Shape[pos].Attributes = {
            ...curAttrs,
            Type: shapePropType ?? curAttrs.Type ?? editableArea?.Attributes?.Type,
            Size: shapePropSize ?? curAttrs.Size ?? editableArea?.Attributes?.Size,
          };
        }
      }

      payload = {
        holeNumber: 0,
        id_courseGPSVector: editableArea?._id,
        name: editableArea?.label,
        points: editPolygonData,
        type: CourseGPSVectorMapUpdateValues[`${editableArea?.type}`],
      };
    }

    dispatch(updateCourseMapData(temp_courseMapData));

    if (shapePropSize || editableArea?.Attributes?.Size) {
      payload.sizeAttribute = shapePropSize || editableArea?.Attributes?.Size;
    }
    if (shapePropType || editableArea?.Attributes?.Type) {
      payload.typeAttribute = shapePropType || editableArea?.Attributes?.Type;
    }
    if (shapePropDesc || editableArea?.Attributes?.Description) {
      payload.descriptionAttribute =
        shapePropDesc || editableArea?.Attributes?.Description;
    }
    // editableArea?.label === "Sand"
    const persistedAttrs = temp_courseMapData?.[`${name}`]?.Shapes?.Shape?.[pos]?.Attributes;
    const existingAttrs = persistedAttrs ?? editableArea?.Attributes;
    if (editableArea?.label === "Sand") {
      payload = {
        ...payload,
        descriptionAttribute: bunkerPolygonDesc ?? existingAttrs?.Description,
        typeAttribute: bunkerPolygonType ?? existingAttrs?.Type,
      };
    }
   else if (editableArea?.label === "Bridge") {
      payload = { ...payload, descriptionAttribute: bridgePropertiesDesc ?? existingAttrs?.Description };
    }
    else if (editableArea?.label === "Background") {
      payload = {
        ...payload,
        descriptionAttribute: backgroundShapeDesc ?? existingAttrs?.Description,
        typeAttribute: backgroundShapeType ?? existingAttrs?.Type,
      };
    } else if (editableArea?.label === "Tree") {
      payload = {
        ...payload,
        descriptionAttribute: markerTreeDesc ?? existingAttrs?.Description,
        typeAttribute: markerTreeType ?? existingAttrs?.Type,
        sizeAttribute: markerTreeSize ?? existingAttrs?.Size,
      };
    }else if(editableArea?.label === "Cliff"){
      payload={
        ...payload,
        descriptionAttribute: cliffPropertiesDesc ?? existingAttrs?.Description,
        typeAttribute: cliffPropertiesType ?? existingAttrs?.Type
      }
    } else if(editableArea?.label === "Nativearea"){
      payload={
        ...payload,
        name: "NativeArea",
        descriptionAttribute: nativeAreaPropertiesDesc ?? existingAttrs?.Description,
        typeAttribute: nativeAreaPropertiesType ?? existingAttrs?.Type,
        sizeAttribute: nativeAreaPropertiesSize ?? existingAttrs?.Size
      }
    }
     else if(editableArea?.label === "Fixtures"){
      payload={
        ...payload,
        typeAttribute: fixturePropertiesType ?? existingAttrs?.Type,
        sizeAttribute: fixturePropertiesSize ?? existingAttrs?.Size
      }
    }
     else if(editableArea?.label === "Forest"){
      payload={
        ...payload,
        typeAttribute: forestPolygonType ?? existingAttrs?.Type,
      }
    }
    else if(editableArea?.label === "Creek"){
      payload={ ...payload, sizeAttribute: creekSizeRedux ?? existingAttrs?.Size }
    }
    else if(editableArea?.label === "Lava"){
      payload={ ...payload, typeAttribute: lavaTypeRedux ?? existingAttrs?.Type }
    }
    else if(editableArea?.label === "Residence"){
      payload={
        ...payload,
        descriptionAttribute: residenceDescRedux ?? existingAttrs?.Description,
        typeAttribute: residenceTypeRedux ?? existingAttrs?.Type,
        sizeAttribute: residenceSizeRedux ?? existingAttrs?.Size,
      }
    }
    else if(editableArea?.label === "Condo" || editableArea?.label === "Hotel" || editableArea?.label === "Business"){
      payload={
        ...payload,
        descriptionAttribute: buildingDescRedux ?? existingAttrs?.Description,
        typeAttribute: buildingTypeRedux ?? existingAttrs?.Type,
        sizeAttribute: buildingSizeRedux ?? existingAttrs?.Size,
      }
    }
    else if(editableArea?.label === "ParkingLot"){
      payload={ ...payload, descriptionAttribute: parkingLotDescRedux ?? existingAttrs?.Description }
    }
    else if(editableArea?.label === "Street"){
      payload={
        ...payload,
        descriptionAttribute: streetDescRedux ?? existingAttrs?.Description,
        sizeAttribute: streetSizeRedux ?? existingAttrs?.Size,
      }
    }
    else if(editableArea?.label === "Fence"){
      payload={
        ...payload,
        descriptionAttribute: fenceDescRedux ?? existingAttrs?.Description,
        sizeAttribute: fenceSizeRedux ?? existingAttrs?.Size,
      }
    }
    else if(editableArea?.label === "Water"){
      payload={
        ...payload,
        descriptionAttribute: waterDescRedux ?? existingAttrs?.Description,
        typeAttribute: waterTypeRedux ?? existingAttrs?.Type,
        sizeAttribute: waterSizeRedux ?? existingAttrs?.Size,
      }
    }
    else if(editableArea?.label === "Path"){
      payload={
        ...payload,
        descriptionAttribute: pathDescRedux ?? existingAttrs?.Description,
      }
    }
    else if(editableArea?.label === "Clubhouse"){
      payload={
        ...payload,
        descriptionAttribute: clubhouseDescRedux ?? existingAttrs?.Description,
        typeAttribute: clubhouseTypeRedux ?? existingAttrs?.Type,
        sizeAttribute: clubhouseSizeRedux ?? existingAttrs?.Size,
      }
    }
    else if(editableArea?.label === "PracticeBunker"){
      payload={
        ...payload,
        descriptionAttribute: bunkerPolygonDesc ?? existingAttrs?.Description,
        typeAttribute: bunkerPolygonType ?? existingAttrs?.Type,
      }
    }

    updateCourseGPSVectorMap(payload);
    // }
  };
    const [propertiesChange, setPropertiesChange] = useState()

  const handleCoursePolygonDataUpdate = (
    editPolygonData,
    editableArea,
    // bunkerPolygonType,
    // bunkerPolygonDesc
  ) => {
    let data =
      typeof editPolygonData === "object" //typeof array is also object
        ? convertCoursePolygonDataToString(editPolygonData)
        : editPolygonData;
    let isHoleItem = isShapeHoleItem(editableArea);
    if (isHoleItem) {
      const sourceCourseMapData = courseMapDataLatestRef.current ?? courseMapData;
      if (!sourceCourseMapData) return;
      let temp_courseMapData = structuredClone(sourceCourseMapData);
      let temp_Holes = temp_courseMapData?.Holes.Hole;
      if (temp_Holes) {
        let selectedMapElement =
          temp_Holes[editableArea?.hole - 1][editableArea?.label];
        if (selectedMapElement.Shapes.Shape?.length === 1) {
          selectedMapElement.Shapes.Shape[0].Points = data;
        } else {
          let pos = selectedMapElement.Shapes.Shape?.findIndex(
            (s) => s.id === editableArea?._id
          );
          selectedMapElement.Shapes.Shape[pos].Points = data;
        }
        temp_Holes[editableArea?.hole - 1][editableArea?.label] =
          selectedMapElement;
        temp_courseMapData.Holes.Hole = temp_Holes;
        dispatch(updateCourseMapData(temp_courseMapData));
        // update bunker jun24
        let payload = {
          // holeNumber: editableArea?.hole - 1,
          holeNumber: editableArea?.hole,
          id_courseGPSVector: editableArea?._id,
          name: editableArea?.label,
          points: [...editPolygonData],
          type: CourseGPSVectorMapUpdateValues[`${editableArea?.type}`],
        };

      
        payload = {
          ...payload,
          typeAttribute: bunkerPolygonType ?? editableArea?.Attributes?.Type,
          descriptionAttribute: bunkerPolygonDesc ?? editableArea?.Attributes?.Description,
        };
        updateCourseGPSVectorMap(payload);
        // if(editableArea?.label === "Bunker"){
        // updateCourseGPSVectorMap(payloadForEditBunkerPolygon);
        // }else{
        // updateCourseGPSVectorMap(payload);

        // }
      }
    }
  };


  useEffect(() => {
    if (editPolygonData) {
      if (editableArea && editPolygonData ) {
        if (editableArea?.hole && editableArea?.hole === -1) {
          // handleFacilityPolygonUpdate()
          handleFacilityDataUpdate(editPolygonData, editableArea);
        } else {

  handleCoursePolygonDataUpdate(
            editPolygonData,
            editableArea,
            // bunkerPolygonType,
            // bunkerPolygonDesc
          );
          setPropertiesChange((prev) =>
            prev && prev._id === editableArea?._id
              ? {
                  ...prev,
                  list: Array.isArray(editPolygonData[0])
                    ? [editPolygonData]
                    : [editPolygonData.map((p) => [p.lat, p.lng])],
                }
              : prev
          );
        }
      }
    }

    setEditPolygonData(null);
    // clearEditableModeVariables();
  }, [editPolygonData]);

  useEffect(() => {
            if(!editPolygonData && !editMarkerData){
    if (!propertiesChange || propertiesChange?._id !== editableAreaRef.current?._id) return;
    if (skipNextAttributeOnlySaveRef.current) {
      return;
    }
    // Guard: on the FIRST evaluation for a newly-selected shape, just record the id and return.
    // The popup init will dispatch the shape's own Attributes into Redux, which re-triggers this
    // effect. By then the guard matches, and the diff check (Redux vs propertiesChange.Attributes)
    // will correctly see no change — preventing a spurious save fired purely by selection while
    // stale Redux from a previous edit is still in flight.
    if (hydratedPropertiesChangeIdRef.current !== propertiesChange?._id) {
      hydratedPropertiesChangeIdRef.current = propertiesChange?._id;
      return;
    }

    const pointsArray = (propertiesChange?.list?.[0] || []).map(([lat, lng]) => ({ lat, lng }));
    const holeNumber = propertiesChange?.hole === -1 ? 0 : propertiesChange?.hole;
    const originalAttributes = propertiesChange?.Attributes ?? {};
    const hasAttributeChanged = (nextValue, currentValue) =>
      nextValue !== null && nextValue !== undefined && nextValue !== currentValue;
            let payload = {
        holeNumber: holeNumber,
        id_courseGPSVector: propertiesChange?._id,
        name: propertiesChange?.label,
        points: pointsArray,
        type: CourseGPSVectorMapUpdateValues[`${propertiesChange?.type}`],
    };


           if( (propertiesChange?.label === "Sand" || propertiesChange?.label === "Bunker" || propertiesChange?.label === "PracticeBunker") &&
      bunkerPolygonType !== null && bunkerPolygonDesc !== null &&
      ( bunkerPolygonType !== propertiesChange?.Attributes?.Type ||
    bunkerPolygonDesc !== propertiesChange?.Attributes?.Description)){

       payload = {...payload,
        typeAttribute: bunkerPolygonType,
        descriptionAttribute: bunkerPolygonDesc,
      };

           updateCourseGPSVectorMap(payload);

      }else if(
             propertiesChange?.label === "Nativearea" &&
       propertiesChange?.Attributes && (
          (nativeAreaPropertiesDesc !== null  && nativeAreaPropertiesDesc !== propertiesChange?.Attributes?.Description) ||
          (nativeAreaPropertiesType !== null && nativeAreaPropertiesType !== propertiesChange?.Attributes?.Type) ||
          (nativeAreaPropertiesSize !== null && nativeAreaPropertiesSize !== propertiesChange?.Attributes?.Size)
      )
      ){
          payload = {...payload,
            name: "NativeArea",
           descriptionAttribute: nativeAreaPropertiesDesc,
            sizeAttribute: nativeAreaPropertiesSize,
            typeAttribute: nativeAreaPropertiesType
      };
        updateCourseGPSVectorMap(payload);
      }
      else if(bridgePropertiesDesc !== null && propertiesChange?.Attributes && bridgePropertiesDesc !== propertiesChange?.Attributes?.Description){
        payload = { ...payload,holeNumber: 0, descriptionAttribute: bridgePropertiesDesc };
         updateCourseGPSVectorMap(payload);

      }
      else if(propertiesChange?.label === "Cliff" && propertiesChange?.Attributes && (
        (cliffPropertiesDesc !== null && cliffPropertiesDesc !== propertiesChange?.Attributes?.Description) ||
        (cliffPropertiesType !== null && cliffPropertiesType !== propertiesChange?.Attributes?.Type)
      )){

        payload = { ...payload,holeNumber: 0,
          descriptionAttribute: cliffPropertiesDesc,
          typeAttribute: cliffPropertiesType
        };
        updateCourseGPSVectorMap(payload);
      }
          else if(propertiesChange?.label === "Forest" && forestPolygonType !== null && forestPolygonType !== propertiesChange?.Attributes?.Type){
      payload ={...payload, typeAttribute: forestPolygonType}
      updateCourseGPSVectorMap(payload);

    }
    else if(propertiesChange?.label === "Fixtures" && (
        hasAttributeChanged(fixturePropertiesType, originalAttributes?.Type) ||
        hasAttributeChanged(fixturePropertiesSize, originalAttributes?.Size)
      )
    ){
      payload = {...payload,
        typeAttribute: fixturePropertiesType,
        sizeAttribute: fixturePropertiesSize
      };
      updateCourseGPSVectorMap(payload);
    }
    else if(propertiesChange?.label === "Creek" &&
      hasAttributeChanged(creekSizeRedux, originalAttributes?.Size)
    ){
      payload = {...payload, sizeAttribute: creekSizeRedux};
      updateCourseGPSVectorMap(payload);
    }
    else if(propertiesChange?.label === "Lava" &&
      hasAttributeChanged(lavaTypeRedux, originalAttributes?.Type)
    ){
      payload = {...payload, typeAttribute: lavaTypeRedux};
      updateCourseGPSVectorMap(payload);
    }
    else if(propertiesChange?.label === "Residence" && (
        hasAttributeChanged(residenceDescRedux, originalAttributes?.Description) ||
        hasAttributeChanged(residenceTypeRedux, originalAttributes?.Type) ||
        hasAttributeChanged(residenceSizeRedux, originalAttributes?.Size)
      )
    ){
      payload = {...payload,
        descriptionAttribute: residenceDescRedux,
        typeAttribute: residenceTypeRedux,
        sizeAttribute: residenceSizeRedux
      };
      updateCourseGPSVectorMap(payload);
    }
    else if((propertiesChange?.label === "Condo" || propertiesChange?.label === "Hotel" || propertiesChange?.label === "Business") && (
        hasAttributeChanged(buildingDescRedux, originalAttributes?.Description) ||
        hasAttributeChanged(buildingTypeRedux, originalAttributes?.Type) ||
        hasAttributeChanged(buildingSizeRedux, originalAttributes?.Size)
      )
    ){
      payload = {...payload,
        descriptionAttribute: buildingDescRedux,
        typeAttribute: buildingTypeRedux,
        sizeAttribute: buildingSizeRedux
      };
      updateCourseGPSVectorMap(payload);
    }
    else if(propertiesChange?.label === "ParkingLot" &&
      hasAttributeChanged(parkingLotDescRedux, originalAttributes?.Description)
    ){
      payload = {...payload, descriptionAttribute: parkingLotDescRedux};
      updateCourseGPSVectorMap(payload);
    }
    else if(propertiesChange?.label === "Street" && (
        hasAttributeChanged(streetDescRedux, originalAttributes?.Description) ||
        hasAttributeChanged(streetSizeRedux, originalAttributes?.Size)
      )
    ){
      payload = {...payload,
        descriptionAttribute: streetDescRedux,
        sizeAttribute: streetSizeRedux
      };
      updateCourseGPSVectorMap(payload);
    }
    else if(propertiesChange?.label === "Fence" && (
        hasAttributeChanged(fenceDescRedux, originalAttributes?.Description) ||
        hasAttributeChanged(fenceSizeRedux, originalAttributes?.Size)
      )
    ){
      payload = {...payload,
        descriptionAttribute: fenceDescRedux,
        sizeAttribute: fenceSizeRedux
      };
      updateCourseGPSVectorMap(payload);
    }
    else if(propertiesChange?.label === "Water" && (
        hasAttributeChanged(waterDescRedux, originalAttributes?.Description) ||
        hasAttributeChanged(waterTypeRedux, originalAttributes?.Type) ||
        hasAttributeChanged(waterSizeRedux, originalAttributes?.Size)
      )
    ){
      payload = {...payload,
        descriptionAttribute: waterDescRedux,
        typeAttribute: waterTypeRedux,
        sizeAttribute: waterSizeRedux
      };
      updateCourseGPSVectorMap(payload);
    }
    else if(propertiesChange?.label === "Path" &&
      hasAttributeChanged(pathDescRedux, originalAttributes?.Description)
    ){
      payload = {...payload, descriptionAttribute: pathDescRedux};
      updateCourseGPSVectorMap(payload);
    }
    else if(propertiesChange?.label === "Clubhouse" && (
        hasAttributeChanged(clubhouseDescRedux, originalAttributes?.Description) ||
        hasAttributeChanged(clubhouseTypeRedux, originalAttributes?.Type) ||
        hasAttributeChanged(clubhouseSizeRedux, originalAttributes?.Size)
      )
    ){
      payload = {...payload,
        descriptionAttribute: clubhouseDescRedux,
        typeAttribute: clubhouseTypeRedux,
        sizeAttribute: clubhouseSizeRedux
      };
      updateCourseGPSVectorMap(payload);
    }
    else if(propertiesChange?.label === "Background" && (
        hasAttributeChanged(backgroundShapeType, originalAttributes?.Type) ||
        hasAttributeChanged(backgroundShapeDesc, originalAttributes?.Description)
      )
    ){
      payload = {...payload,
        descriptionAttribute: backgroundShapeDesc,
        typeAttribute: backgroundShapeType
      };
      updateCourseGPSVectorMap(payload);
    }
    else if(propertiesChange?.label === "Tree" && (
        hasAttributeChanged(markerTreeDesc, originalAttributes?.Description) ||
        hasAttributeChanged(markerTreeType, originalAttributes?.Type) ||
        hasAttributeChanged(markerTreeSize, originalAttributes?.Size)
      )
    ){
      payload = {...payload,
        descriptionAttribute: markerTreeDesc,
        typeAttribute: markerTreeType,
        sizeAttribute: markerTreeSize
      };
      updateCourseGPSVectorMap(payload);
    }
    else if(propertiesChange?.label === "Vegetation" && (
        hasAttributeChanged(shapePropType, originalAttributes?.Type) ||
        hasAttributeChanged(shapePropSize, originalAttributes?.Size)
      )
    ){
      payload = {...payload,
        typeAttribute: shapePropType,
        sizeAttribute: shapePropSize
      };
      updateCourseGPSVectorMap(payload);
    }
    else if(propertiesChange?.label === "Rock" &&
      hasAttributeChanged(shapePropSize, originalAttributes?.Size)
    ){
      payload = {...payload, sizeAttribute: shapePropSize};
      updateCourseGPSVectorMap(payload);
    }


}

  }, [propertiesChange, editPolygonData, editMarkerData, bunkerPolygonType, bunkerPolygonDesc ,
    nativeAreaPropertiesDesc, nativeAreaPropertiesSize,nativeAreaPropertiesType,
  bridgePropertiesDesc,cliffPropertiesDesc,cliffPropertiesType,forestPolygonType,
  fixturePropertiesType,fixturePropertiesSize,
  creekSizeRedux,lavaTypeRedux,
  residenceDescRedux,residenceTypeRedux,residenceSizeRedux,
  buildingDescRedux,buildingTypeRedux,buildingSizeRedux,
  parkingLotDescRedux,streetDescRedux,streetSizeRedux,
  fenceDescRedux,fenceSizeRedux,
  waterDescRedux,waterTypeRedux,waterSizeRedux,
  pathDescRedux,clubhouseDescRedux,clubhouseTypeRedux,clubhouseSizeRedux,
  backgroundShapeType,backgroundShapeDesc,
  markerTreeDesc,markerTreeType,markerTreeSize,
  shapePropType,shapePropSize])
  


  useEffect(() => {
    if (editMarkerData) {
      // as most of marker data is related courseGPSMappingData

      if (editableArea && editMarkerData) {
        if (editableArea?.hole && editableArea?.hole === -1) {
          handleFacilityDataUpdate(editPolygonData, editableArea);
        } else {
          handleCourseMarkerDataUpdate();
        }
      }
    }

    setEditMarkerData(null);
    clearEditableModeVariables();
  }, [editMarkerData]);
  const getMapWorld = (categorizedData) => {
    let flytoZone = convertSingleLatLngStringtoFloatArray(
      categorizedData.clubhousecenter[0]?.points,
      " "
    );

    // Reject sentinel / "no-data" markers. Some courses ship a Clubhousecenter
    // of "-1.0 -1.0" or "0 0", which would otherwise center the map in the
    // Atlantic Ocean where there is no satellite imagery (grey tiles).
    const [a, b] = flytoZone;
    const isFinitePair = Number.isFinite(a) && Number.isFinite(b);
    const isSentinel =
      !isFinitePair || (a === -1 && b === -1) || (a === 0 && b === 0);

    if (!isSentinel) {
      const next = [b, a]; // flip to [lat, lon]
      setCurrentLocation(next);
    } else {
      // eslint-disable-next-line no-console
      console.warn("[CourseMap getMapWorld] clubhousecenter sentinel/invalid coords:", flytoZone, "→ using googleLocation fallback");
      const next = [
        googleLocation.geometry.location?.lat,
        googleLocation.geometry.location?.lng,
      ];
      setCurrentLocation(next);
    }

    // flyTo(flytoZone,ZOOM)

    // setMapView(flytoZone,ZOOM)
  };

  const LoadCourseMappingData = () => {
    //Simple Data
    let holewiseHazards = [];
    let teeCenterArray = [];
    // let fcbArray = [];
    let fcbarray = [];
    if (courseGPSMappingData) {
      if (
        !shiftedPlaceholderWarnedRef.current &&
        hasShiftedPlaceholderCoordinates(courseGPSMappingData)
      ) {
        shiftedPlaceholderWarnedRef.current = true;
        toastWarning(
          "Some deleted-marker placeholders on this course are slightly offset from (0,0), likely after a full course shift. Map zoom may behave unexpectedly until the course data is cleaned up."
        );
      }
      courseGPSMappingData?.map((shape, index) => {
        let hazardArray = [];
        let fcbObject = {};
        let holeWiseTeeCenter = [];
        for (let i = 1; i <= courseMapElementLimit.hazard; i++) {
          if (
            shape &&
            shape[`customDesc${i}`] &&
            shape[`customDesc${i}`] !== 0 &&
            shape[`customLat${i}`] &&
            shape[`customLat${i}`] !== 0 &&
            shape[`customName${i}`] &&
            shape[`customName${i}`] !== 0 &&
            shape[`customName${i}`] &&
            shape[`customName${i}`] !== 0
          ) {
            let GPSNameObject = CourseGPSNameListResponse.find(
              (s) => s.name === shape[`customName${i}`]
            );
            hazardArray.push({
              [`customDesc${i}`]: shape[`customDesc${i}`],
              [`customLat${i}`]: shape[`customLat${i}`],
              [`customLon${i}`]: shape[`customLon${i}`],
              [`customName${i}`]: shape[`customName${i}`],
              gpsNameID: GPSNameObject?.id,
              // id: uuidv4() + "_" + i + "_" + shape[`customName${i}`],
              id: 1 + "_" + i + "_" + shape[`customName${i}`],
              holeNumber: shape.holeNumber,
              type: "hazard",
            });
          }
        }
        holewiseHazards.push(hazardArray);
        //adding fcb points

        for (let i = 1; i <= courseMapElementLimit.teeboxcenter; i++) {
          // const element = array[index];
          if (
            shape &&
            shape[`teeLat${i}`] &&
            shape[`teeLat${i}`] !== 0 &&
            shape[`teeLon${i}`] &&
            shape[`teeLon${i}`] !== 0
          )
            holeWiseTeeCenter.push({
              [`teeLat${i}`]: shape[`teeLat${i}`],
              [`teeLon${i}`]: shape[`teeLon${i}`],
              // id: uuidv4() + "_" + i + "_" + shape[`holeNumber`],
              id: 1 + "_" + i + "_" + shape[`holeNumber`],
              holeNumber: shape.holeNumber,
              type: "Teeboxcenter",
            });
        }
        teeCenterArray.push(holeWiseTeeCenter);
        let fcbSingle = [];
        // if (fcbObject["shape.holeNumber"]) {
        if (
          shape.frontLat &&
          shape.frontLat !== 0 &&
          shape.frontLon &&
          shape.frontLon !== 0
        ) {
          fcbSingle.push({
            shape: [shape.frontLat, shape.frontLon],
            // id: uuidv4() + "_" + shape.holeNumber + "_" + "front",
            id: 1 + "_" + shape.holeNumber + "_" + "front",
            place: "front",
            holeNumber: shape.holeNumber,
            type: "fcb",
          });
        }
        if (shape.backLat && shape.backLon) {
          // fcbObject["back"] = {
          //   shape: [shape.backLat, shape.backLon],
          //   id: uuidv4() + "_" + shape.holeNumber + "_" + "back",
          // };
          fcbSingle.push({
            shape: [shape.backLat, shape.backLon],
            // id: uuidv4() + "_" + shape.holeNumber + "_" + "back",
            id: 2 + "_" + shape.holeNumber + "_" + "back",
            place: "back",
            holeNumber: shape.holeNumber,
            type: "fcb",
          });
        }
        if (shape.centerLat && shape.centerLon) {
          // fcbObject["center"] = {
          //   shape: [shape.centerLat, shape.centerLon],
          //   id: uuidv4() + "_" + shape.holeNumber + "_" + "center",
          // };
          fcbSingle.push({
            shape: [shape.centerLat, shape.centerLon],
            // id: uuidv4() + "_" + shape.holeNumber + "_" + "center",
            id: 3 + "_" + shape.holeNumber + "_" + "center",
            place: "center",
            holeNumber: shape.holeNumber,
            type: "fcb",
          });
        }
        if (fcbObject["center"] && fcbObject["back"] && fcbObject["front"])
          fcbObject["holeNumber"] = shape.holeNumber;
        // fcbArray.push(fcbObject);
        fcbarray.push(fcbSingle);

        // }
      });

      setTeeCenterData(teeCenterArray);
      // setFcbData(fcbArray);
      setFcbData(fcbarray);
      setHazardData(holewiseHazards);
      return { teeCenterArray, fcbarray, holewiseHazards };
    }
  };
  const LoadShapeData = () => {
    try {
      if (!_.isEmpty(addedLayer)) {
        addedLayer?.map((layer) => {
          removeSelectedLayer(layer); //removing previously added layer
        });
      }
      if (courseMapData && courseGPSMappingData) {
        let clubhousecenterCustomID;
        //clubhousecenter
        if (
          clubhousecenterCoords.clubLat !== 0 &&
          clubhousecenterCoords.clubLon !== 0
        ) {
          clubhousecenterCustomID = "clbc_" + id_courseFromQuery;
          let customShape = {
            clubLat: clubhousecenterCoords.clubLat,
            clubLon: clubhousecenterCoords.clubLon,
            id_course: parseInt(id_courseFromQuery),
            _id: clubhousecenterCustomID,
            zone: "clubhousecenter",
            label: "Clubhousecenter",
          };

          setClubHouseCenterData(customShape);
        } else {
          setClubHouseCenterData({});
        }

        const { holewiseHazards, fcbarray, teeCenterArray } =
          LoadCourseMappingData();
        const conversionPromise = convertCourseMapData(courseMapData);
        conversionPromise
          .then((result) => {
            const { boundList: boundaryList, elementWiseList } =
              getCourseMapBoundsAndElementWisePoints(result, true);

            // setAllPolyData(elementWiseList);
            getMapWorld(result);
            // boundaryList is populated only from "background" in
            // getCourseMapBoundsAndElementWisePoints. Courses without a
            // Background fall through to setView(currentLocation), which
            // is fragile (clubhousecenter may carry sentinel coords like
            // (-1,-1)). Fall back to **perimeters only** — per-hole
            // boundaries that are guaranteed manually drawn on the course,
            // so they cover the same envelope a Background would.
            let safeBoundary = boundaryList || [];
            if (safeBoundary.length === 0 && Array.isArray(elementWiseList)) {
              // 1st preference: perimeters — manually drawn per-hole boundaries
              safeBoundary = elementWiseList
                .filter((el) => el?.zone === "Perimeter")
                .flatMap((el) => el?.list?.[0] || []);
              if (safeBoundary.length === 0) {
                // 2nd preference: any hole-wise polygon/line (exclude markers
                // and facility shapes, which may carry sentinel coords).
                safeBoundary = elementWiseList
                  .filter(
                    (el) =>
                      el?.hole > 0 &&
                      (el?.type === "polygon" || el?.type === "line")
                  )
                  .flatMap((el) => el?.list?.[0] || []);
              }
            }
            // Drop NaN entries either way.
            const validBoundary = safeBoundary.filter(
              (pt) =>
                Array.isArray(pt) &&
                Number.isFinite(pt[0]) &&
                Number.isFinite(pt[1])
            );
            if (validBoundary.length > 0) {
              setBoundLatLng(L.latLngBounds(validBoundary));
            } else {
              // Keep the original (empty) bounds so the conditional falls
              // through to currentLocation — same as pre-existing behavior.
              setBoundLatLng(L.latLngBounds(boundaryList));
            }
            // const data = elementWiseList?.filter((item) => item.hole > 0);
            const data = elementWiseList?.filter(
              (item) => item?.zone !== "Teeboxcenter" && item.hole > 0
            );
            const courseOnlyData = elementWiseList?.filter(
              (item) => item.hole < 0
            );
             createVisibleCourseItemList(courseMapData).then(
              ({
                CourseElements: visibleList,
                FacilityElements: visibleFacilityElements,
              }) => {
                if (visibleList.length) {
                  for (let i = 0; i < visibleList.length; i++) {
                    // Add a "Hazard" property with the corresponding holewiseHazards data
                    visibleList[i].Hazard = {
                      isElementVisible: true,
                      idList: holewiseHazards[i]?.map((item) => item.id),
                    };
                    visibleList[i].Teeboxcenter = {
                      // using teeboxcenter from courseMapdata instead of courseGPSMappingData"
                      isElementVisible: true,
                      idList: teeCenterArray[i]?.map((item) => item.id),
                    };
                    visibleList[i].fcb = {
                      // using teeboxcenter from courseMapdata instead of courseGPSMappingData"
                      isElementVisible: true,
                      idList: fcbarray[i]?.map((item) => item.id),
                    };
                  }
                } else {
                  for (let i = 0; i < courseMapData?.LayoutHoles; i++) {
                    // Or use any suitable number of iterations
                    visibleList.push({
                      Hazard: {
                        isElementVisible: true,
                        idList: holewiseHazards[i]?.map((item) => item.id),
                      },
                      Teeboxcenter: {
                        isElementVisible: true,
                        idList: teeCenterArray[i]?.map((item) => item.id),
                      },
                      fcb: {
                        isElementVisible: true,
                        idList: fcbarray[i]?.map((item) => item.id),
                      },
                    });
                  }
                }
const allPracticeGreenShapeIds= courseMapData?.PracticeGreen?.Shapes?.Shape?.map(shape => shape.id);
                  const allPracticeBunkerShapeIds= courseMapData?.PracticeBunker?.Shapes?.Shape?.map(shape => shape.id);
           

                visibleFacilityElements = {
                  ...visibleFacilityElements,
                  Clubhousecenter: {
                    ...visibleFacilityElements.Clubhousecenter,
                    idList: [clubhousecenterCustomID],
                  },
                  Tree: {
                    ...visibleFacilityElements.Tree,
                    isGroupVisible: visibleFacilityElementList?.Tree?.isGroupVisible ? true : false,
                  },
                  Practicegreen: {
                    ...visibleFacilityElements.Practicegreen,
                    idList: allPracticeGreenShapeIds,
                  },
                 Practicebunker: {
                  ...visibleFacilityElements.Practicebunker,
                   idList:  allPracticeBunkerShapeIds
                  }
                };

                if (!_.isEmpty(editableArea) && visibleCourseElements?.length) {
                  dispatch(setVisibleCourseElements(visibleCourseElements));
                  dispatch(
                    setVisibleFacilityElements(visibleFacilityElementList)
                  );
                } else if (
                  !_.isEmpty(movableShapeData) &&
                  visibleCourseElements?.length
                ) {
                  dispatch(setVisibleCourseElements(visibleCourseElements));
                  dispatch(
                    setVisibleFacilityElements(visibleFacilityElementList)
                  );
                } else {

                  dispatch(setVisibleCourseElements(visibleList));
                  dispatch(setVisibleFacilityElements(visibleFacilityElements));

                }
                clearEditableModeVariables();
              }
            );

            
            //need to merge holeWise with holewiseHazards
            // setHoleWiseData(holeWise);
            setCourseWiseData(courseOnlyData);
            setHoleWiseData(data);

            dispatch(setTransformedCourseData(courseOnlyData));
            dispatch(setTransformedHoleData(data));
            let temp = [
              {
                icon: `${asset.Union}`,
                isData: true,
                isIcon: true,
                title: "Hole Features",
                // data:{...holeWise}
                data: { ...courseMapData?.Holes?.Hole },
                // data: convertedCourseMapData?.Holes?.Hole,
                tooltipText: "Hole Features"
              },
              {
                icon: `${asset.alert}`,
                isData: true,
                isIcon: true,
                title: "Facility Hazard Features",
                data: { holes: [] },
                 tooltipText: "Facility Hazards"
              },
              {
                icon: `${asset.star}`,
                isData: true,
                isIcon: true,
                title: "Facility",
                data: { holes: [] },
                 tooltipText: "Facility Elements"
              },
            ];

            setMapControlList(temp);
          })
          .catch((err) => {
          });
      }
      setAddedLayer([]);
      setAddedPoints([]);
    } catch (error) {
    }
  };

  useEffect(() => {
    if (fullCourseShift.phase === "processing") {
      shiftReloadPendingRef.current = true;
      return;
    }
    shiftReloadPendingRef.current = false;
    LoadShapeData();
  }, [
    courseMapData,
    courseGPSMapping,
    googleLocation,
    // id_courseFromQuery
    //  courseGPSMappingData
  ]);

  // Soft-delete invalid shapes (line <2 pts, polygon <3 pts) returned by the server.
  //
  // Safety rails (per code review):
  // - Background / Perimeter are NEVER auto-deleted. They are bounds-critical;
  //   removing them blanks out the bounds list and breaks tile rendering on
  //   courses that depend on them. Surface a warning toast instead so an
  //   operator can review manually.
  // - An id is marked "cleaned" only after the server confirms Status === 1.
  //   Failed deletes stay eligible for retry on the next courseMapData change.
  // - In-flight dispatches are tracked to prevent duplicate sends when the
  //   effect re-fires before the previous request resolves.
  // - One refetch happens after the batch completes, not one per delete.
  useEffect(() => {
    if (!courseMapData) return;
    const CRITICAL_KEEP = new Set(["background", "perimeter"]);
    const allInvalid = collectInvalidShapes(courseMapData);

    const eligible = allInvalid.filter(
      (s) =>
        !cleanedInvalidIdsRef.current.has(s.id) &&
        !cleanupInFlightIdsRef.current.has(s.id)
    );
    if (eligible.length === 0) return;

    const criticalInvalid = eligible.filter((s) =>
      CRITICAL_KEEP.has(String(s.name).toLowerCase())
    );
    const deletable = eligible.filter(
      (s) => !CRITICAL_KEEP.has(String(s.name).toLowerCase())
    );

    if (criticalInvalid.length > 0) {
      // Mark them cleaned so we don't re-warn on every refetch in this session.
      criticalInvalid.forEach((s) => cleanedInvalidIdsRef.current.add(s.id));
      // eslint-disable-next-line no-console
      console.warn("[CourseMap Cleanup] Bounds-critical shape(s) appear malformed but were NOT auto-deleted:", criticalInvalid);
      toastWarning(
        `${criticalInvalid.length} bounds-critical shape(s) (Background/Perimeter) look malformed — please review manually.`
      );
    }

    if (deletable.length === 0) return;

    const dispatches = deletable.map((s) => {
      cleanupInFlightIdsRef.current.add(s.id);
      const payload = { id_courseGPSVector: s.id, active: 0 };

      return dispatch(
        course_gps_vector_map_update({
          body: payload,
          user: { secretKey: secret_Key, userName: username },
        })
      )
        .then((res) => {
          cleanupInFlightIdsRef.current.delete(s.id);
          const ok = res?.payload?.data?.Status === 1;
          if (ok) {
            cleanedInvalidIdsRef.current.add(s.id);
          }
          return { id: s.id, meta: s, ok, data: res?.payload?.data };
        })
        .catch((err) => {
          cleanupInFlightIdsRef.current.delete(s.id);
          // eslint-disable-next-line no-console
          console.error("[CourseMap Cleanup] dispatch threw for id", s.id, err);
          return { id: s.id, meta: s, ok: false, error: err };
        });
    });

    Promise.all(dispatches).then((results) => {
      const successes = results.filter((r) => r.ok);
      const failures = results.filter((r) => !r.ok);

      successes.forEach((r) => {
        const where = r.meta.hole > 0 ? ` (hole ${r.meta.hole})` : "";
        toastWarning(
          `Removed invalid ${r.meta.name}${where}: ${r.meta.pointCount} point${r.meta.pointCount === 1 ? "" : "s"}`
        );
      });

      if (failures.length > 0) {
        // eslint-disable-next-line no-console
        console.warn("[CourseMap Cleanup] server REJECTED", failures.length, "delete(s):", failures);
        toastError(
          `Failed to clean ${failures.length} invalid shape(s) — they will be retried on next load.`
        );
      }

      if (successes.length > 0) {
        // One refetch covers all successful deletes.
        dispatch(
          course_map_gps_vector_details({
            body: { id_course: id_courseFromQuery },
            user: { secretKey: secret_Key, userName: username },
          })
        );
      }
    });
  }, [courseMapData]);

  // Disable edit mode synchronously BEFORE passive effects remove layers from FeatureGroup.
  // This prevents Leaflet Draw's _disableLayerEdit from crashing on stale layer references.
  useLayoutEffect(() => {
    try {
      const dc = editControlRef.current;
      if (dc) {
        dc._toolbars.edit._modes.edit.handler.disable();
      }
    } catch (error) {
      // Silently handle - edit mode may not be active
    }
  }, [editableArea]);

  useEffect(() => {
    try {
      const dc = editControlRef.current;
      if (dc) {
        if (!editableArea || _.isEmpty(editableArea)) {
          eventEmitter.emit(events.addMarkerToggle, { visible: false });
        } else {
          const shape = editableAreaRef.current;
          const isBackground = shape?.label === "Background";
          const handler = dc._toolbars.edit._modes.edit.handler;
          if (handler?.options?.poly) {
            const alreadyIntersecting =
              (shape?.type === "polygon" || shape?.type === "line") &&
              hasSelfIntersection(shape?.list?.[0], shape?.type === "polygon");
            handler.options.poly.allowIntersection =
              isBackground || alreadyIntersecting;
            if (alreadyIntersecting && !isBackground) {
              toastWarning(
                "This shape's outline already crosses itself, so edge-crossing protection is disabled for this edit. Please repair the crossing or redraw the shape."
              );
            }
          }
          handler.enable();
        }
      }
    } catch (error) {
      // Handler may reference unmounted layers during rapid switching
    }
  }, [editableArea]);

  const cancelEdit = () => {
    if (editableArea) {
      clearEditableModeVariables();
      try {
        const dc = editControlRef.current;
        if (dc) {
          dc._toolbars.edit._modes.edit.handler.disable();
          eventEmitter.emit(events.addMarkerToggle, { visible: false });
        }
      } catch (error) {
        // Silently handle stale handler references to unmounted layers
      }
    }
    if (selectedZoneType) {
      resetDrawingMode();
    }
  };

const drawingLayerRef = useRef(null);

  const _onMounted = (e) => {
    editControlRef.current = e;
    const div = document.getElementById("GoogleMap");
    setMapDomEl(div);
  };


const handleUndoLastPoint = () => {
  const layer = drawingLayerRef.current;
  if (!layer) return;

  const drawControl = editControlRef.current;
  const handler = drawControl?._toolbars?.draw?._activeMode?.handler;

  if (!handler) return;

  let latlngs = layer.getLatLngs();

  if (Array.isArray(latlngs[0])) {
   
    const coords = latlngs[0];
    if (coords.length <= 1) return;
    coords.pop();
    layer.setLatLngs([coords]);
  } else {
 
    if (latlngs.length <= 1) return;
    latlngs.pop();
    layer.setLatLngs(latlngs);
  }

 
  const markers = handler._markers;
  if (markers && markers.length > 0) {
    const lastMarker = markers.pop();
    lastMarker.remove(); 
  }


  layer.redraw();
};

useEffect(() => {
  const handleKeyDown = (e) => {
    // Check if the user is focused on an input field
    const isInputFocused = 
      e.target.tagName === 'INPUT' || 
      e.target.tagName === 'TEXTAREA' || 
      e.target.isContentEditable;
    
    // Only handle Backspace/Delete if not focused on an input field and actively drawing
    if (!isInputFocused && (e.key === "Backspace" || e.key === 'Delete')) {
      const layer = drawingLayerRef.current;
      if (layer) {
        e.preventDefault();
        handleUndoLastPoint();
      }
    }
  };

  window.addEventListener("keydown", handleKeyDown);

  return () => {
    window.removeEventListener("keydown", handleKeyDown);
  };
}, []);

  const enableScaleDraw = () => {
    setIsScaleDrawEnabled(true);
    dispatch(clearSelectedCourseZoneType());
    cancelEdit();
    drawPolyLine(); //starts drawing polyline
  };

  const saveEditedChanges = useCallback(() => {
    try {
      const dc = editControlRef.current;
      if (dc) {
        dc._toolbars.edit._modes.edit.handler.save();
        dc._toolbars.edit._modes.edit.handler.disable();
      }
    } catch (error) {
    }
  }, []);

  
const changeMapLayer = () => {
  if (!mapRef.current) return;

  const currentZoom = mapRef.current.getZoom();

  if (!isGoogleView && currentZoom > 19) {
    // Скидання зуму до 19 без анімації, якщо був більший
    mapRef.current.setZoom(19, { animate: false });
  }

  setIsGoogleView(!isGoogleView);
};

  const isMoveEnabled = useIsMoveModeEnabled();
  const selectMovableElement = () => {
    if (isSelectionDeleteEnabledRef.current) {
      exitSelectionDeleteMode();
    }
    if (fullCourseShift.activeRef.current) {
      fullCourseShift.cancel();
    }
    if (!isMoveEnabled) {
      dispatch(setEnableMoveMode(true));
    } else {
      dispatch(setEnableMoveMode(false));
    }
  };

  const exitSelectionDeleteMode = () => {
    isSelectionDeleteEnabledRef.current = false;
    setIsSelectionDeleteEnabled(false);
    setSelectionCandidates(null);
    disableDraw();
  };

  const toggleSelectionDeleteMode = () => {
    if (isSelectionDeleteEnabledRef.current) {
      exitSelectionDeleteMode();
      return;
    }
    setIsScaleDrawEnabled(false);
    eventEmitter.emit(events.resetDrawingMode);
    eventEmitter.emit("resetMoveMode");
    isSelectionDeleteEnabledRef.current = true;
    setIsSelectionDeleteEnabled(true);
    dispatch(setIsDrawingStatus(true));
    drawRectangle();
  };

  const cancelSelectionDelete = () => {
    setSelectionCandidates(null);
    drawRectangle();
  };

  const confirmSelectionDelete = () => {
    if (!selectionCandidates) return;
    const { vectorShapes, teeCenters } = selectionCandidates;

    const requests = vectorShapes.map((shape) =>
      dispatch(
        course_gps_vector_map_update({
          body: { id_courseGPSVector: shape._id, active: 0 },
          user: { secretKey: secret_Key, userName: username },
        })
      )
        .then((res) => ({
          count: 1,
          ok: res?.payload?.data?.Status === 1,
        }))
        .catch(() => ({ count: 1, ok: false }))
    );

    if (teeCenters.length > 0) {
      const temp_courseGPSMappingData = structuredClone(courseGPSMappingData);
      teeCenters.forEach((tee) => {
        const idx = Number(tee.id.split("_")[1]);
        const holeData = temp_courseGPSMappingData[tee.holeNumber - 1];
        if (holeData) {
          holeData[`teeLat${idx}`] = 0;
          holeData[`teeLon${idx}`] = 0;
        }
      });
      dispatch(updateCourseMappingData(temp_courseGPSMappingData));
      requests.push(
        dispatch(
          course_mapping_gps_update({
            body: {
              id_course: parseInt(id_courseFromQuery),
              clubLat: courseGPSMapping?.clubLat,
              clubLon: courseGPSMapping?.clubLon,
              GPSList: temp_courseGPSMappingData,
            },
            user: { secretKey: secret_Key, userName: username },
          })
        )
          .then((res) => ({
            count: teeCenters.length,
            ok: res?.payload?.data?.Status === 1,
          }))
          .catch(() => ({ count: teeCenters.length, ok: false }))
      );
    }

    Promise.all(requests).then((results) => {
      const deleted = results
        .filter((r) => r.ok)
        .reduce((sum, r) => sum + r.count, 0);
      const failed = results
        .filter((r) => !r.ok)
        .reduce((sum, r) => sum + r.count, 0);
      if (deleted > 0) {
        toastSuccess(`${deleted} object${deleted === 1 ? "" : "s"} deleted.`);
      }
      if (failed > 0) {
        toastError(`${failed} object${failed === 1 ? "" : "s"} failed to delete.`);
      }
      if (results.some((r) => r.ok)) {
        setTimeout(() => {
          dispatch(
            course_map_gps_vector_details({
              body: { id_course: id_courseFromQuery },
              user: { secretKey: secret_Key, userName: username },
            })
          );
        }, 500);
      }
    });

    exitSelectionDeleteMode();
  };

  const BasicControls = [
    {
      icon: `${asset.tools}`,
      isData: false,
      isIcon: true,
      title: "Tools",
      callBack: () => {
        eventEmitter.emit(events.openToolsMenu, { visible: !isToolsMenuOpen });
      },
      isActive: isToolsMenuOpen,
      tooltipText: "Tools"
    },
    {
      icon: `${asset.plusIcon}`,
      isData: false,
      isIcon: true,
      title: "ZoomIn",
      callBack: zoomIn,
      isActive: false,
       tooltipText: "Zoom In"
    },
    {
      icon: `${asset.minus}`,
      isData: false,
      isIcon: true,
      title: "ZoomOut",
      callBack: zoomOut,
      isActive: false,
      tooltipText: "Zoom Out"

    },
    {
      icon: isGoogleView ? `${asset.googleIcon}` : `${asset.azureIcon}`,
      isData: false,
      isIcon: true,
      title: "ToggleMap",
      callBack: changeMapLayer,
      // callBack: () => {
      //   eventEmitter.emit(events.openMapLayerType, { visible: true });
      // },
      isActive: false,
      tooltipText: "Map Type"
    },
    {
      icon: `${asset.scale}`,
      isData: false,
      isIcon: true,
      title: "Scale",
      callBack: enableScaleDraw,
      isActive: false,
      tooltipText: "Measure"
      // callBack:drawPolyLineWithMenu
    },
    {
      icon: `${asset.moveIcon}`,
      isData: false,
      isIcon: true,
      title: "Move",
      callBack: selectMovableElement,
      isActive: isMoveEnabled ? true : false,
      tooltipText: "Shift Tool"
      // callBack:drawPolyLineWithMenu
    },
    {
      icon: `${asset.deleteSelection}`,
      isData: false,
      isIcon: true,
      title: "DeleteBySelection",
      callBack: toggleSelectionDeleteMode,
      isActive: isSelectionDeleteEnabled ? true : false,
      tooltipText: "Delete by Selection",
    },
    {
      icon: `${asset.infoIcon}`,
      isData: false,
      isIcon: true,
      title: "Move",
      callBack: () => {
        eventEmitter.emit(events.openCourseInfoModal, { visible: true });
      },
      isActive: false,
      tooltipText: "Info"
      // callBack:drawPolyLineWithMenu
    },
    {
      icon: `${asset.scorecardIcon}`,
      isData: false,
      isIcon: true,
      title: "Move",
      callBack: () => {
        eventEmitter.emit(events.openScoreCardInfoModal, { visible: true });
      },
      isActive: false,
      tooltipText: "Scorecard"
      // callBack:drawPolyLineWithMenu
    },
    {
      icon: `${asset.editIcon}`,
      isData: false,
      isIcon: true,
      title: "Move",
      callBack: () => {
        eventEmitter.emit(events.openMappingNotesModal, { visible: true });
      },
      isActive: false,
      tooltipText: "Notes"
    },

  ];

  const filterDrawActions = useCallback(
    (e) => {
      if (isSelectionDeleteEnabledRef.current) {
        exitSelectionDeleteMode();
      }
      if (fullCourseShift.activeRef.current) {
        fullCourseShift.cancel();
      }
      if (e.type === drawShapeType.polyline && e.event === drawEventType.add) {
        drawPolyLine();
        // setVisibleAddMarker(true)
      } else if (
        e.type === drawShapeType.polygon &&
        e.event === drawEventType.add
      ) {

        drawPolygon(); // listens to drawPolygon
      } else if (
        e.type === drawShapeType.point &&
        e.event === drawEventType.add
      ) {
        drawPoint();
      }
      dispatch(setIsDrawingStatus(true));
    },
    [selectedZoneType]
  );

  const handleAutoGenerateBackground = useCallback(() => {
    const result = generateBackgroundFromPerimeters(holeWiseDataRef.current, clubhousecenterCoords);
    if (!result) {
      toastError("No hole perimeters found. Map at least one perimeter first.");
      return;
    }

    // Check if Background already exists — store ID for update instead of delete+create
    const existingBg = courseWiseDataRef.current?.find(
      (s) => s?.label === "Background"
    );
    autoGenExistingBgRef.current = existingBg?._id || null;
    clearEditableModeVariables();

    setAutoGenPreview(result.leafletCoords);
    setAddedPoints([result.pointsString]);
    dispatch(
      setSelectedCourseZoneType({
        hole: -1,
        type: "polygon",
        element: "Background",
        data: [],
      })
    );
    eventEmitter.emit(events.addMarkerToggle, { visible: true });
  }, [courseMapData]);

  const autoAddTeeboxCenter = (addedPoints) => {
    let temp_courseGPSMappingData = structuredClone(courseGPSMappingData);
    let selectedHoleObject =
      temp_courseGPSMappingData[selectedZoneTypeRef.current.hole - 1];
    let selectedCustomNumber = 0;


    if (!_.isEmpty(temp_courseGPSMappingData)) {
      for (let i = 1; i <= courseMapElementLimit.teeboxcenter; i++) {
        if (
          !selectedHoleObject?.hasOwnProperty(`teeLon${i}`) ||
          selectedHoleObject[`teeLon${i}`] === 0
        ) {
          selectedCustomNumber = i;
          break;
        }
      }
      if (selectedCustomNumber === 0) {
        toastError(
          "All teebox center slots are already in use for this hole."
        );
        return;
      }
      let addedTeeData = {
        [`teeLat${selectedCustomNumber}`]: Number(autoTeeCenterCoords[0]),
        [`teeLon${selectedCustomNumber}`]: Number(autoTeeCenterCoords[1]),
      };
      temp_courseGPSMappingData[selectedZoneTypeRef.current.hole - 1] = {
        ...temp_courseGPSMappingData[selectedZoneTypeRef.current.hole - 1],
        ...addedTeeData,
        holeNumber: selectedZoneTypeRef.current.hole
      };
    } else {
      let addedTeeData = {
        [`teeLat1`]: Number(autoTeeCenterCoords[0]),
        [`teeLon1`]: Number(autoTeeCenterCoords[1]),
      };
      temp_courseGPSMappingData[selectedZoneTypeRef.current.hole - 1] = {
        holeNumber: selectedZoneTypeRef.current.hole,
        ...addedTeeData,
      };
    }

    dispatch(updateCourseMappingData(temp_courseGPSMappingData));

    let payload = {
      id_course: parseInt(id_courseFromQuery),
      clubLat: courseGPSMapping?.clubLat,
      clubLon: courseGPSMapping?.clubLon,
      // id_courseLayout: 2,
      GPSList: temp_courseGPSMappingData,
    };
    updateCourseMappingGPSData(payload);
  };
  const addAutoFCBcenter = (centerPoints) => {
    let temp_courseGPSMappingData = structuredClone(courseGPSMappingData);
    let selectedHoleObject =
    temp_courseGPSMappingData[selectedZoneTypeRef.current.hole - 1];
  

    if (!_.isEmpty(selectedHoleObject)){
     if(selectedHoleObject?.centerLat === 0){
        if(centerPoints){
          let fcbType = "center";
            temp_courseGPSMappingData[selectedZoneTypeRef.current.hole - 1] = {
          ...temp_courseGPSMappingData[selectedZoneTypeRef.current.hole - 1],
            
           [`${fcbType}Lat`]: Number(centerPoints[0]),
            [`${fcbType}Lon`]: Number(centerPoints[1]),
      
          };
        }
      }else{
        if(centerPoints){
          let fcbType = "center";
            temp_courseGPSMappingData[selectedZoneTypeRef.current.hole - 1] = {
          ...temp_courseGPSMappingData[selectedZoneTypeRef.current.hole - 1],
            
           [`${fcbType}Lat`]: Number(centerPoints[0]),
            [`${fcbType}Lon`]: Number(centerPoints[1]),
      
          };
        }
      }
    }else{
      let fcbType = "center";
      let addedFCBCenter = {
        [`${fcbType}Lat`]: Number(centerPoints[0]),
            [`${fcbType}Lon`]: Number(centerPoints[1]),
      }
      temp_courseGPSMappingData[selectedZoneTypeRef.current.hole - 1] = {
        holeNumber: selectedZoneTypeRef.current.hole,
        ...addedFCBCenter,
      };
    }
   
      dispatch(updateCourseMappingData(temp_courseGPSMappingData));
    
      let payload = {
        id_course: parseInt(id_courseFromQuery),
        clubLat: courseGPSMapping?.clubLat,
        clubLon: courseGPSMapping?.clubLon,
        // id_courseLayout: 2,
        GPSList: temp_courseGPSMappingData,
      };
      updateCourseMappingGPSData(payload);
      }

  const autoAddFCB = (intersectingPointsFeature)=> {
let temp_courseGPSMappingData = structuredClone(courseGPSMappingData);
  
    const centralPathLatLng = L.latLng(centralPathLine.geometry.coordinates[0]);
  const bintersectingLatLng = L.latLng(intersectingPointsFeature[0]?.geometry.coordinates);
  const cintersectingLatLng = L.latLng(intersectingPointsFeature[1]?.geometry.coordinates);
  const distanceToBintersecting = centralPathLatLng.distanceTo(bintersectingLatLng);
  const distanceToCintersecting = centralPathLatLng.distanceTo(cintersectingLatLng);
 let selectedHoleObject =
    temp_courseGPSMappingData[selectedZoneTypeRef.current.hole - 1];
  const nearest = distanceToBintersecting < distanceToCintersecting ? '1stId' : '2ndId';


    const frontFCB = nearest === "1stId" ? intersectingPointsFeature[0]?.geometry.coordinates : intersectingPointsFeature[1]?.geometry.coordinates;
    const backFCB  =  nearest === "1stId" ? intersectingPointsFeature[1]?.geometry.coordinates : intersectingPointsFeature[0]?.geometry.coordinates;



      if(!_.isEmpty(selectedHoleObject)){
      if(selectedHoleObject){
        if(frontFCB){
          let fcbType = "front";
            temp_courseGPSMappingData[selectedZoneTypeRef.current.hole - 1] = {
          ...temp_courseGPSMappingData[selectedZoneTypeRef.current.hole - 1],
            
           [`${fcbType}Lat`]: Number(frontFCB[0]),
            [`${fcbType}Lon`]: Number(frontFCB[1]),
          };
        }
         if(backFCB){
             let fcbType = "back";
            temp_courseGPSMappingData[selectedZoneTypeRef.current.hole - 1] = {
          ...temp_courseGPSMappingData[selectedZoneTypeRef.current.hole - 1],
            
           [`${fcbType}Lat`]: Number(backFCB[0]),
            [`${fcbType}Lon`]: Number(backFCB[1]),
      
          };
        }
      }
    }else{
      let fcbTypeF = "front";
      let fcbTypeB = "back";
      let addedFCBFront = {
        [`${fcbTypeF}Lat`]: Number(frontFCB[0]),
            [`${fcbTypeF}Lon`]: Number(frontFCB[1]),
      }
      let addedFCBBack = {
        [`${fcbTypeB}Lat`]: Number(backFCB[0]),
            [`${fcbTypeB}Lon`]: Number(backFCB[1]),
      }
      temp_courseGPSMappingData[selectedZoneTypeRef.current.hole - 1] = {
        holeNumber: selectedZoneTypeRef.current.hole,
        ...addedFCBFront,
        ...addedFCBBack
      };
    }


    dispatch(updateCourseMappingData(temp_courseGPSMappingData));
      let payload = {
      id_course: parseInt(id_courseFromQuery),
      clubLat: courseGPSMapping?.clubLat,
      clubLon: courseGPSMapping?.clubLon,
      // id_courseLayout: 2,
      GPSList: temp_courseGPSMappingData,
    };
    updateCourseMappingGPSData(payload);
  }
useEffect(()=> {
  setCentralPathLine({})
},[selectedZoneTypeRef?.current?.hole])
useEffect(() => {
const holeNumber = selectedZoneTypeRef.current.hole -1
 if(courseMapData?.Holes?.Hole[holeNumber]?.Green ){
  const coordsArrayData = courseMapData?.Holes?.Hole[holeNumber]?.Green?.Shapes?.Shape[0]?.Points
  const coordsArrayGreen = coordsArrayData?.split(',')
  const result = coordsArrayGreen?.map(coord => {
    const [longitude, latitude] = coord?.split(' ').map(Number);
    return [latitude, longitude]; 

  });

  result?.push(result[0]);
  const polygon =result && turf?.polygon([result]); // Create a polygon from the polygon points

if(centralPathLine?.type && polygon){
  const intersectingPoints = turf?.lineIntersect(centralPathLine, polygon);
  if (intersectingPoints?.features.length >= 2) {
    setAutoFrontPoints(intersectingPoints?.features[0].geometry.coordinates)
    
    // setAutoBackPoints(intersectingPoints?.features[1].geometry.coordinates)
 if(selectedZoneTypeRef.current.element === "Centralpath" && justCreatedCentralPathRef.current){
    autoAddFCB(intersectingPoints?.features)
    justCreatedCentralPathRef.current = false;
 }
  } else {
   console.warn('No intersection found');
 }
}


 }
 if(selectedZoneTypeRef.current.element === "Green" && autoCenterFCBPoints){
  addAutoFCBcenter(autoCenterFCBPoints)
}

}, [courseMapData])



  const autoRedraw = () => {
    setAutoGenPreview(null);
    let addedShapeCount = selectedZoneTypeRef.current.data?.length || 1;
    if (
      continuousHoleFeatures?.includes(
        selectedZoneTypeRef.current?.element?.toLowerCase()
      )
    ) {
      if (selectedZoneTypeRef.current.hole === -1) {
        emitDrawPolygon();
        return;
      }

      if (
        addedShapeCount ===
        courseMapElementLimit[`${selectedZoneType?.element?.toLowerCase()}`] - 1
      ) {
        eventEmitter.emit(events.disableDraw);
        toastSuccess("Elements Added");
      } else {
        emitDrawPolygon();
      }
    } else {
      eventEmitter.emit(events.disableDraw);
    }
  };

  const saveNewShape = async (e) => {
    if(selectedZoneType.element === 'Bunker'){
      setPreAddedBunkerProp(e)
    }
    
    setAddedTreeProperties(e)
    let temp_courseMapData = structuredClone(courseMapData);
    let temp_courseGPSMappingData = structuredClone(courseGPSMappingData);
    let _clubLat = courseGPSMapping?.clubLat;
    let _clubLon = courseGPSMapping?.clubLon;
    if (HoleElements.includes(selectedZoneType?.element)) {
      let tempHole = temp_courseMapData?.Holes?.Hole;
      if (!_.isEmpty(addedPoints)) {
        let lngLatList = addedPoints?.map((item, index) =>
          convertLatLngStringToLngLatString(item)
        );
        let sepLatLngArr = addedPoints[0]?.split(" ");
        let res = await LatLngStringtoLatLngArray(sepLatLngArr);

        let payload = {
          id_course: parseInt(id_courseFromQuery),
          holeNumber: selectedZoneType?.hole,
          name: selectedZoneType.element,
          type: CourseGPSVectorMapUpdateValues[`${selectedZoneType?.type}`],
          points: res,
          descriptionAttribute: e?.polygonDesc,
          typeAttribute: e?.polygonType,
          // typeAttribute: 1 or 2
          // descriptionAttribute: 1 or 2
          // sizeAttribute:1 or 2 or 3
        };
        let gps_create_response = dispatch(
          course_gps_vector_map_create({
            body: payload,
            user: {
              secretKey: secret_Key,
              userName: username,
            },
          })
        ).then((res) => {
          if (res?.payload?.data?.Status !== 1) {
            toastError(`CourseGPSVectorMapCreate failed (id_course: ${id_courseFromQuery}). Server response: ${JSON.stringify(res?.payload?.data)}`);
            throw new Error("CourseGPSVectorMapCreate rejected");
          }
          dispatch(
            course_map_gps_vector_details({
              body: {
                id_course: id_courseFromQuery,
              },
              user: {
                secretKey: secret_Key,
                userName: username,
              },
            })
          );
        });

        if (selectedZoneTypeRef.current.element === "Teebox") {
            
          autoAddTeeboxCenter(addedPoints);
        }
        gps_create_response
          .then((res) => {
            let apiShapeID = res?.payload?.data?.id_courseGPSVector;
            _.forEach(lngLatList, (lngLatString, y) => {

              if (
                !_.isEmpty(tempHole) &&
                tempHole[selectedZoneType?.hole - 1] &&
                tempHole[selectedZoneType?.hole - 1][selectedZoneType?.element]
              ) {
                //Adding to existing shapeList
                tempHole[selectedZoneType?.hole - 1][
                  selectedZoneType?.element
                ]?.Shapes.Shape?.push({
                  Points: lngLatString,
                  // id: Math.floor(100000 + Math.random() * 900000),
                  id: apiShapeID,
                });
                tempHole[selectedZoneType?.hole - 1][
                  selectedZoneType?.element
                ].ShapeCount =
                  tempHole[selectedZoneType?.hole - 1][
                    selectedZoneType?.element
                  ].ShapeCount + 1;
              } else {

                // TODO~ will have to get ID from API call then add to local shapeList or else editing the added shape will produce error
                //Creating a brand new shape
                if (_.isEmpty(tempHole)) {
                  tempHole.push({
                    [`${selectedZoneType?.element}`]: {
                      ShapeCount: 1,
                      Shapes: {
                        Shape: [
                          {
                            Points: lngLatString,
                            id: apiShapeID,
                            // id: Math.floor(100000 + Math.random() * 900000), // testing with static ID
                          },
                        ],
                      },
                    },
                  });
                } else {
                  tempHole[selectedZoneType?.hole - 1][
                    selectedZoneType?.element
                  ] = {
                    ShapeCount: 1,
                    Shapes: {
                      Shape: [
                        {
                          Points: lngLatString,
                          id: apiShapeID,
                          // id: Math.floor(100000 + Math.random() * 900000), // testing with static ID
                        },
                      ],
                    },
                  };
                }
              }
            });

            temp_courseMapData.Holes.Hole = tempHole;
            dispatch(updateCourseMapData(temp_courseMapData));

            // if (selectedZoneTypeRef.current.element === "Teebox") {
              
            //   autoAddTeeboxCenter(addedPoints);
            // }
            // else 
            if(selectedZoneType.element === "Centralpath"){
              
            
              // autoAddFrontFCB(autoFrontPoints)

            }else if(selectedZoneTypeRef.current.element === "Green"){
              
              // addAutoFCBcenter(autoCenterFCBPoints)
            }
          })
          .catch((err) => {
          });
      }
    } 
    else {
    
      if (selectedZoneType.hole && selectedZoneType.hole === -1) {
        if (!_.isEmpty(addedPoints)) {
          let lngLatList = addedPoints?.map((item, index) =>
            convertLatLngStringToLngLatString(item)
          );
          let sepLatLngArr = addedPoints[0]?.split(" ");
          let res = await LatLngStringtoLatLngArray(sepLatLngArr);

          let MarkerType = e?.markerType;
          let selectedMarkerMod2 = e?.selectedMarkerMod2;
          let shapeDescription = e?.shapeDesc;
          let payload = {
            id_course: parseInt(id_courseFromQuery),
            holeNumber: 0,
            name:
              selectedZoneType.element === "Nativearea"
                ? "NativeArea"
                : selectedZoneType.element,
            type: CourseGPSVectorMapUpdateValues[`${selectedZoneType?.type}`],
            points: res,
            typeAttribute: MarkerType,
            sizeAttribute: selectedMarkerMod2,
            // descriptionAttribute: 1 or 2
          };

          if (e?.shapeDesc) {
            //&& selectedZoneType.element==='Background'
            payload = { ...payload, descriptionAttribute: e?.shapeDesc };
          }
          if (e?.polygonType !== undefined && e?.polygonDesc !== undefined) {
            payload = {
              ...payload,
              descriptionAttribute: e?.polygonDesc,
              typeAttribute: e?.polygonType,
            };
          }
          if (e?.bridgeDesc !== undefined) {
            payload = { ...payload, descriptionAttribute: e?.bridgeDesc };
          }
          if (e?.backgroundShapeType  !== undefined && e?.backgroundShapeDesc !== undefined) {
            payload = {
              ...payload,
              descriptionAttribute: e?.backgroundShapeDesc,
              typeAttribute: e?.backgroundShapeType,
            };
          }

          if (
            (e?.treeMarkerDesc !== undefined && e?.treeMarkerSize,
            e?.treeMarkerType)
          ) {
            payload = {
              ...payload,
              descriptionAttribute: e?.treeMarkerDesc,
              typeAttribute: e?.treeMarkerType,
              sizeAttribute: e?.treeMarkerSize,
            };
          }
          if (e?.cliffPolygonDesc !== undefined && e?.cliffPolygonType !== undefined) {
            payload = {
              ...payload,
              descriptionAttribute: e?.cliffPolygonDesc,
              typeAttribute: e?.cliffPolygonType,
            };
          }
          if (
            e?.nativeAreaPolygonDesc !== undefined &&
            e?.nativeAreaPolygonSize !== undefined &&
            e?.nativeAreaPolygonType !== undefined
          ) {
            payload = {
              ...payload,
              descriptionAttribute: e?.nativeAreaPolygonDesc,
              typeAttribute: e?.nativeAreaPolygonType,
              sizeAttribute: e?.nativeAreaPolygonSize,
            };
          }
          if (
            e?.fixtureMarkerType !== undefined &&
            e?.fixtureMarkerSize !== undefined
          ) {
            payload = {
              ...payload,
              typeAttribute: e?.fixtureMarkerType,
              sizeAttribute: e?.fixtureMarkerSize,
            };
          }
          if(e?.forestPolygonType  !== undefined ){
            payload = {
              ...payload,
              typeAttribute: e?.forestPolygonType,
            };
          }
          if(e?.creekSizeValue !== undefined){
            payload = { ...payload, sizeAttribute: e?.creekSizeValue };
          }
          if(e?.lavaTypeValue !== undefined){
            payload = { ...payload, typeAttribute: e?.lavaTypeValue };
          }
          if(e?.residenceDescValue !== undefined && e?.residenceTypeValue !== undefined && e?.residenceSizeValue !== undefined){
            payload = {
              ...payload,
              descriptionAttribute: e?.residenceDescValue,
              typeAttribute: e?.residenceTypeValue,
              sizeAttribute: e?.residenceSizeValue,
            };
          }
          if(e?.buildingDescValue !== undefined && e?.buildingTypeValue !== undefined && e?.buildingSizeValue !== undefined){
            payload = {
              ...payload,
              descriptionAttribute: e?.buildingDescValue,
              typeAttribute: e?.buildingTypeValue,
              sizeAttribute: e?.buildingSizeValue,
            };
          }
          if(e?.parkingLotDescValue !== undefined){
            payload = { ...payload, descriptionAttribute: e?.parkingLotDescValue };
          }
          if(e?.streetDescValue !== undefined && e?.streetSizeValue !== undefined){
            payload = {
              ...payload,
              descriptionAttribute: e?.streetDescValue,
              sizeAttribute: e?.streetSizeValue,
            };
          }
          if(e?.fenceDescValue !== undefined && e?.fenceSizeValue !== undefined){
            payload = {
              ...payload,
              descriptionAttribute: e?.fenceDescValue,
              sizeAttribute: e?.fenceSizeValue,
            };
          }
          if(e?.waterDescValue !== undefined && e?.waterTypeValue !== undefined && e?.waterSizeValue !== undefined){
            payload = {
              ...payload,
              descriptionAttribute: e?.waterDescValue,
              typeAttribute: e?.waterTypeValue,
              sizeAttribute: e?.waterSizeValue,
            };
          }
          if(e?.pathDescValue !== undefined){
            payload = { ...payload, descriptionAttribute: e?.pathDescValue };
          }
          if(e?.clubhouseDescValue !== undefined && e?.clubhouseTypeValue !== undefined && e?.clubhouseSizeValue !== undefined){
            payload = {
              ...payload,
              descriptionAttribute: e?.clubhouseDescValue,
              typeAttribute: e?.clubhouseTypeValue,
              sizeAttribute: e?.clubhouseSizeValue,
            };
          }

          const existingBgId = autoGenExistingBgRef.current;
          autoGenExistingBgRef.current = null;

          if (existingBgId && selectedZoneType.element === "Background") {
            // UPDATE existing background with new auto-generated points
            let updatePayload = {
              holeNumber: 0,
              id_courseGPSVector: existingBgId,
              name: "Background",
              points: res,
              type: payload.type,
            };
            if (payload.typeAttribute !== undefined) {
              updatePayload.typeAttribute = payload.typeAttribute;
            }
            if (payload.descriptionAttribute !== undefined) {
              updatePayload.descriptionAttribute = payload.descriptionAttribute;
            }

            updateCourseGPSVectorMap(updatePayload);

            // Update local courseMapData with new points
            const lngLatString = lngLatList[0];
            if (temp_courseMapData["Background"]?.Shapes?.Shape) {
              const pos = temp_courseMapData["Background"].Shapes.Shape.findIndex(
                (s) => s.id === existingBgId
              );
              if (pos >= 0) {
                temp_courseMapData["Background"].Shapes.Shape[pos].Points = lngLatString;
                temp_courseMapData["Background"].Shapes.Shape[pos].Attributes = {
                  ...temp_courseMapData["Background"].Shapes.Shape[pos].Attributes,
                  Type: payload.typeAttribute,
                  Description: payload.descriptionAttribute,
                };
              }
            }

            dispatch(updateCourseMapData(temp_courseMapData));
            autoRedraw();
          } else {
            // CREATE new shape
            dispatch(
              course_gps_vector_map_create({
                body: payload,
                user: {
                  secretKey: secret_Key,
                  userName: username,
                },
              })
            ).then((res) => {
              if (res?.payload?.data?.Status !== 1) {
                toastError(`CourseGPSVectorMapCreate failed (id_course: ${id_courseFromQuery}). Server response: ${JSON.stringify(res?.payload?.data)}`);
                return;
              }
              dispatch(
                course_map_gps_vector_details({
                  body: {
                    id_course: id_courseFromQuery,
                  },
                  user: {
                    secretKey: secret_Key,
                    userName: username,
                  },
                })
              );

              let apiShapeID = res?.payload?.data?.id_courseGPSVector;
              _.forEach(lngLatList, (lngLatString, y) => {
                if (temp_courseMapData[`${selectedZoneType.element}`]) {
                  if (
                    temp_courseMapData[`${selectedZoneType.element}`].ShapeCount
                  ) {
                    temp_courseMapData[
                      `${selectedZoneType.element}`
                    ].ShapeCount += 1;
                  } else {
                    temp_courseMapData[
                      `${selectedZoneType.element}`
                    ].ShapeCount = 1;
                  }
                  let _dataObject = {
                    id: apiShapeID,
                    Points: lngLatString,
                    Attributes: {
                      Type: MarkerType,
                      Size: selectedMarkerMod2,
                    },
                  };
                  if (shapeDescription) {
                    _dataObject = {
                      ..._dataObject,
                      Attributes: {
                        ..._dataObject.Attributes,
                        Description: shapeDescription,
                      },
                    };
                  }
                  if (selectedZoneType.element === "Forest" && e?.forestPolygonType !== undefined) {
                    _dataObject.Attributes = { ..._dataObject.Attributes, Type: e.forestPolygonType };
                  }

                  temp_courseMapData[
                    `${selectedZoneType.element}`
                  ].Shapes.Shape.push(_dataObject);
                } else {
                  let _dataObject = {
                    id: apiShapeID,
                    Points: lngLatString,
                    Attributes: {
                      Type: MarkerType,
                      Size: selectedMarkerMod2,
                    },
                  };
                  if (shapeDescription) {
                    _dataObject = {
                      ..._dataObject,
                      Attributes: {
                        ..._dataObject.Attributes,
                        Description: shapeDescription,
                      },
                    };
                  }
                  if (selectedZoneType.element === "Forest" && e?.forestPolygonType !== undefined) {
                    _dataObject.Attributes = { ..._dataObject.Attributes, Type: e.forestPolygonType };
                  }

                  temp_courseMapData[`${selectedZoneType.element}`] = {
                    ShapeCount: 1,
                    Shapes: {
                      Shape: [_dataObject],
                    },
                  };
                }
              });

              dispatch(updateCourseMapData(temp_courseMapData));
              autoRedraw();
            });
          }
          return;
        }
      }

      if (selectedZoneType?.element === "Hazard") {
        //adding Hazard
        let hazardTypeInt = e?.markerType;
        let GPSNameObject = CourseGPSNameListResponse.find(
          (s) => s.id === Number(hazardTypeInt)
        );
        let selectedHoleObject =
          temp_courseGPSMappingData[selectedZoneTypeRef.current.hole - 1];
        let selectedCustomNumber = 0;
        for (let i = 1; i <= courseMapElementLimit.hazard; i++) {
          if (
            !selectedHoleObject.hasOwnProperty(`customLat${i}`) ||
            selectedHoleObject[`customLat${i}`] === 0
          ) {
            //adding to customLat/Lon which is missing
            selectedCustomNumber = i;
            break;
          }
        }
        if (selectedCustomNumber === 0) {
          toastError("All hazard slots are already in use for this hole.");
          setAddedPoints([]);
          autoRedraw();
          return;
        }
        let addedHazardData = {
          [`customLat${selectedCustomNumber}`]: Number(
            addedPoints[0].split(",")[0]
          ),
          [`customLon${selectedCustomNumber}`]: Number(
            addedPoints[0].split(",")[1]
          ),
          [`customDesc${selectedCustomNumber}`]: GPSNameObject?.description,
          [`customName${selectedCustomNumber}`]: GPSNameObject?.name,
          [`id_courseGPSName${selectedCustomNumber}`]: Number(hazardTypeInt), // does not come from details API
        };
        temp_courseGPSMappingData[selectedZoneTypeRef.current.hole - 1] = {
          ...temp_courseGPSMappingData[selectedZoneTypeRef.current.hole - 1],
          ...addedHazardData,
        };
      }

      if (selectedZoneType?.element === "Teeboxcenter") {
        //adding Hazard
        let selectedHoleObject =
          temp_courseGPSMappingData[selectedZoneTypeRef.current.hole - 1];
        let selectedCustomNumber = 0;

        for (let i = 1; i <= courseMapElementLimit.teeboxcenter; i++) {
          if (
            !selectedHoleObject.hasOwnProperty(`teeLon${i}`) ||
            selectedHoleObject[`teeLon${i}`] === 0
          ) {
            selectedCustomNumber = i;
            break;

            //adding to customLat/Lon which is missing
            // let addedTeeData = {
            //   [`teeLat${i}`]: Number(addedPoints[0].split(",")[0]),
            //   [`teeLon${i}`]: Number(addedPoints[0].split(",")[1]),
            // };
            // temp_courseGPSMappingData[selectedZoneTypeRef.current.hole - 1] = {
            //   ...temp_courseGPSMappingData[
            //     selectedZoneTypeRef.current.hole - 1
            //   ],
            //   ...addedTeeData,
            // };
          }
        }
        if (selectedCustomNumber === 0) {
          toastError(
            "All teebox center slots are already in use for this hole."
          );
          setAddedPoints([]);
          autoRedraw();
          return;
        }
        let addedTeeData = {
          [`teeLat${selectedCustomNumber}`]: Number(
            addedPoints[0].split(",")[0]
          ),
          [`teeLon${selectedCustomNumber}`]: Number(
            addedPoints[0].split(",")[1]
          ),
        };
        temp_courseGPSMappingData[selectedZoneTypeRef.current.hole - 1] = {
          ...temp_courseGPSMappingData[selectedZoneTypeRef.current.hole - 1],
          ...addedTeeData,
        };
      }
      if (selectedZoneType?.element === "fcb") {
        let fcbType = e?.markerType;

        temp_courseGPSMappingData[selectedZoneTypeRef.current.hole - 1] = {
          ...temp_courseGPSMappingData[selectedZoneTypeRef.current.hole - 1],
          [`${fcbType}Lat`]: Number(addedPoints[0].split(",")[0]),
          [`${fcbType}Lon`]: Number(addedPoints[0].split(",")[1]),

        };
      }

      if (selectedZoneType?.element === "Clubhousecenter") {

        _clubLat = Number(addedPoints[0].split(",")[0]); //insert value
        _clubLon = Number(addedPoints[0].split(",")[1]); //insert value
      }

      if (
        !temp_courseGPSMappingData[selectedZoneTypeRef.current.hole - 1]
          ?.holeNumber
      ) {
        temp_courseGPSMappingData[selectedZoneTypeRef.current.hole - 1] = {
          ...temp_courseGPSMappingData[selectedZoneTypeRef.current.hole - 1],
          holeNumber: selectedZoneTypeRef.current.hole,
        };
      }

      dispatch(updateCourseMappingData(temp_courseGPSMappingData));
      dispatch(updateClubHouseCenter({ clubLat: _clubLat, clubLon: _clubLon }));

      let payload = {
        id_course: parseInt(id_courseFromQuery),
        clubLat: _clubLat,
        clubLon: _clubLon,
        // id_courseLayout: 2,
        GPSList: temp_courseGPSMappingData,
      };
      updateCourseMappingGPSData(payload);
    }

    setAddedPoints([]); // else  addedPoints have multiple sets of latlongs

    autoRedraw();
  };

  useEffect(() => {
    if (!isNaN(parseInt(associatedCourseData?.searchedCourseName))) {
      dispatch(clearCourseDetailsData()); //clearing previously searched data if course ID was used to search
      dispatch(setSearchedCourseName("")); //clearing previously searched name if course ID was used to search
    }
    return () => {
      dispatch(clearCourseMapDetails());
      dispatch(resetShapeProperties());
      dispatch(removeAllMapData());
      eventEmitter.off(events.addMarkerToggle);
      eventEmitter.emit("resetMoveMode");
      dispatch(setEnableMoveMode(false));
    };
  }, []); //[addedShapePoints]


  useEffect(() => {
    function handleKeyPress(event) {
      try {
        if (isMoveEnabled && movableShapeData) {
          if (event.key === "Enter") {
            let polyData = convertToLatLngArrayOfObject(
              movableShapeData?.list[0]
            );
            if (movableShapeData?.hole && movableShapeData.hole === -1) {
              handleFacilityDataUpdate(polyData, movableShapeData);
            } else {
              handleCoursePolygonDataUpdate(polyData, movableShapeData);
            }
            // eventEmitter.emit("resetMoveMode");
          }
        }
      } catch (error) {
      }
    }
    document.addEventListener("keydown", handleKeyPress);
    return () => {
      document.removeEventListener("keydown", handleKeyPress);
    };
  }, [isMoveEnabled, movableShapeData]);

  useEffect(() => {
    if (isDrawing || isMoveEnabled) {
      imageOverlayTool.stopEdit();
    }
  }, [isDrawing, isMoveEnabled]);

  useEffect(() => {
    imageOverlayTool.clearAll();
  }, [id_courseFromQuery]);

  const getCustomMarker = (shape, color = "grey") => {
    try {
      let label = shape?.label;
      if (!label)
        // for hazard marker
        return L.divIcon({
          className: "custom-marker2",
          html: `<div class="dialog_icon2" style="background-color:${color};text-shadow:1px 1px 1px #000, -1px -1px 0 #000, 1px -1px 0 #000, -1px 1px 0 #000;">
        ${shape?.holeNumber}
        <span style="background-color:${color}"></span>
        </div>`,
        });

      if (label === "Rock") return L.icon(leafletCustomIcon["Rock"]);

      // if (label === "Tree") return L.icon(leafletCustomIcon["Tree"]);
      //replaced tree icon with green circle
      if (label === "Tree") {
        let SizeColor =
          shape?.Attributes?.Description === undefined
            ? ""
            : shape?.Attributes?.Description === 0
            ? ""
            : shape?.Attributes?.Description === 1
            ? defaultCouseMapElementColor.palm
            : shape?.Attributes?.Description === 2
            ? defaultCouseMapElementColor.willow
            : shape?.Attributes?.Description === 3
            ? defaultCouseMapElementColor.desertShrub
            : shape?.Attributes?.Description === 4
            ? defaultCouseMapElementColor.shrub
            : shape?.Attributes?.Description === 5
            ? defaultCouseMapElementColor.conifer
            : shape?.Attributes?.Description === 7
            ? defaultCouseMapElementColor.pine
            : shape?.Attributes?.Description === 8
            ? defaultCouseMapElementColor.cypress
            : shape?.Attributes?.Description === 9
            ? defaultCouseMapElementColor.cactus
            : defaultCouseMapElementColor.deciduous;

        let borderStyle =
          shape?.Attributes?.Type === undefined
            ? ""
            : shape?.Attributes?.Type === 1
            ? `2px solid ${
                shape?.Attributes?.Size === 1
                  ? "#FFFFFF"
                  : shape?.Attributes?.Size === 2
                  ? "#7d8081"
                  : "#000"
              }`
            : `3px solid ${
                shape?.Attributes?.Size === 1
                  ? "#FFFFFF"
                  : shape?.Attributes?.Size === 2
                  ? "#7d8081"
                  : "#000"
              }`;

        return L.divIcon({
          className: "custom-marker2",
          html: `<div class="tree_circle" style="border:${borderStyle};background-color:${SizeColor};text-shadow:1px 1px 1px #000, -1px -1px 0 #000, 1px -1px 0 #000, -1px 1px 0 #000;"/>`,
        });

        // return L.divIcon({
        //   className: "custom-marker2",
        //   html: `<div class="tree_circle" style="background-color:${color};text-shadow:1px 1px 1px #000, -1px -1px 0 #000, 1px -1px 0 #000, -1px 1px 0 #000;"/>`,
        // });
      }

      if (shape?.label === "Teeboxcenter" || shape?.label === "Greencenter")
        label = shape?.hole;

      return L.divIcon({
        className: "custom-marker2",
        html: `<div class="dialog_icon2" style="background-color:${color};text-shadow:1px 1px 1px #000, -1px -1px 0 #000, 1px -1px 0 #000, -1px 1px 0 #000;">
     ${label === "Fixtures" ? "F" : label}
        <span style="background-color:${color}"></span>
        </div>`,
      });
    } catch (error) {
    }
  };
const [addedTreePoint, setAddedTreePoint] = useState();
const [addedTreeProperties, setAddedTreeProperties] = useState()
const [preAddedBunkerProp, setPreAddedBunkerProp] = useState()

  useEffect(()=> {
    if(selectedZoneType?.element === "Bunker" && addedPoints){
      eventEmitter.emit(events.openBunkerElementInModal, { open: false });
    }

    if(selectedZoneType?.element === "Tree" && addedTreePoint){    
      const modifiedArray = addedTreePoint.map((coord) => {
        const [lat, lng] = coord.split(',').map(Number);
        return { lat, lng };
      });
      
 
      let payload = {
        id_course: parseInt(id_courseFromQuery),
        holeNumber: 0,
        name: selectedZoneType.element,
        type: CourseGPSVectorMapUpdateValues[`${selectedZoneType?.type}`],
        points: modifiedArray,
        typeAttribute: addedTreeProperties?.treeMarkerType,
        sizeAttribute: addedTreeProperties?.treeMarkerSize,
        descriptionAttribute: addedTreeProperties?.treeMarkerDesc
      };

      dispatch(
        course_gps_vector_map_create({
          body: payload,
          user: {
            secretKey: secret_Key,
            userName: username,
          },
        })
      ).then((res) => {
        if (res?.payload?.data?.Status !== 1) {
          toastError(`CourseGPSVectorMapCreate failed (id_course: ${id_courseFromQuery}). Server response: ${JSON.stringify(res?.payload?.data)}`);
          return;
        }
        dispatch(
          course_map_gps_vector_details({
            body: {
              id_course: id_courseFromQuery,
            },
            user: {
              secretKey: secret_Key,
              userName: username,
            },
          })
        );
        autoRedraw();
      });

    }else if(selectedZoneType?.element === "Bunker" && preAddedBunkerProp && addedPoints?.length > 0){
      

      const modifiedArray = addedPoints[0]
  .split(" ")
  .map(pair => {
    const [lat, lng] = pair.split(",").map(Number);
    return { lat, lng };
  });
     


     let payload = {
        id_course: parseInt(id_courseFromQuery),
        holeNumber: selectedZoneType?.hole,
        name: selectedZoneType.element,
        type: CourseGPSVectorMapUpdateValues[`${selectedZoneType?.type}`],
        points: modifiedArray,
        typeAttribute: preAddedBunkerProp?.polygonType,
        descriptionAttribute: preAddedBunkerProp?.polygonDesc
      };

      dispatch(
        course_gps_vector_map_create({
          body: payload,
          user: {
            secretKey: secret_Key,
            userName: username,
          },
        })
      ).then((res) => {
        if (res?.payload?.data?.Status !== 1) {
          toastError(`CourseGPSVectorMapCreate failed (id_course: ${id_courseFromQuery}). Server response: ${JSON.stringify(res?.payload?.data)}`);
          return;
        }
        dispatch(
          course_map_gps_vector_details({
            body: {
              id_course: id_courseFromQuery,
            },
            user: {
              secretKey: secret_Key,
              userName: username,
            },
          })
        );
        autoRedraw();
      });

    }
  },[addedTreePoint || preAddedBunkerProp ])
  // const isEditEnabled = (label) => {

  //   // return editableArea === label;
  // };
  
  const isShapeHoleItem = (shape) => {
    return shape && shape.zone
      ? HoleElements.some((s) => s.toLowerCase() === shape?.zone.toLowerCase())
      : false;
  };


  

  const toggleEditMode = (shape) => {
    if (isDrawing) return;
    if (fullCourseShift.activeRef.current) {
      if (fullCourseShift.phase !== "reviewing") return;
      fullCourseShift.finish();
    }

    skipNextAttributeOnlySaveRef.current = false;
    hydratedPropertiesChangeIdRef.current = null;

    if (shape?.hole === -1) {
      if (_.isEmpty(editableAreaRef.current)) {
               setPropertiesChange(shape)
        dispatch(setEditableCourseItem(shape));
      }
      return;
    }

    if (_.isEmpty(editableAreaRef.current)) {
      let isHoleItem = isShapeHoleItem(shape);

      if (isHoleItem) {
        switch (shape?.zone) {
          case "Greencenter":
            if (editableArea?.greenID === shape?.greenID) {
              clearEditableModeVariables();
            } else {
              
              dispatch(setEditableCourseItem(shape));
            }
            break;
          default:
            if (editableArea?._id === shape?._id) {
              // dispatch(clearEditableCourseItem());
              clearEditableModeVariables();
            } else {
              
               setPropertiesChange(shape)

              dispatch(setEditableCourseItem(shape));
            }
            break;
        }
      } else {
        dispatch(setEditableCourseItem(shape));
      }
    }
  };



  // const toggleFacitlyEditMode = (shape) => {
  // };

  const getShapeComponent = (shape) => {
    const polygonOptions = {
      shapetype: "map",
      // Add your custom key and value here
    };
    if (shape?.type === "polygon") {
      return (
        <Polygon
          customIdentifier={polygonOptions}
          color={
            isColor(shape?.mod2)
              ? shape?.mod2
              : defaultCouseMapElementColor[`${shape?.zone}`.toLowerCase()]
              ? defaultCouseMapElementColor[`${shape?.zone}`.toLowerCase()]
              : "grey"
          }
          positions={shape.list}
          pathOptions={{fill:false}} // added to disable full shape select

          eventHandlers={{
            click: (event) => {

              if (!isMoveEnabled) {
                toggleEditMode(shape);
              } else {
                setMovableShapeData(shape);
              }
            },
            mouseover: (event) => {
              // toggleEditMode(shape, clicked);
              const layer = event.target;
              layer.setStyle({ weight: 4 });
              // layer.bringToFront()
            },
            mouseout: (event) => {
              const layer = event.target;

              layer.setStyle({ weight: 3 });
              layer.bringToBack();  // redmine 13727
            },
          }}
          fillColor={
            "transparent"
            // isColor(shape?.mod2)
            //   ? shape?.mod2
            //   : defaultZoneColor[`${shape?.zone}`]
            //   ? defaultZoneColor[`${shape?.zone}`]
            //   : "grey"
          }
          key={shape?.label + shape?.mod2}

          // keyname changes when color changes as color change does not trigger polygon re-render
        >
          {/* {_.isEmpty(editableArea) && ( //show tooltip only when not editing polygon */}
          {/* redmine */}
          
          <Tooltip sticky>{convertToLabelName(shape?.zone)}
            {shape?.Attributes?.Description !== undefined && shape?.Attributes?.Description !== 0 && (
              <><br />{convertToLabelWithAttributesDesc(shape)}</>
            )}
            {shape?.Attributes?.Type !== undefined && shape?.Attributes?.Type !== 0 && (
              <><br />{convertToLabelWithAttributesType(shape)}</>
            )}
            {shape?.Attributes?.Size !== undefined && shape?.Attributes?.Size !== 0 && (
              <><br />{convertToLabelWithAttributesSize(shape)}</>
            )}
          </Tooltip>
          {/* )} */}
        </Polygon>
      );
    }

    if (shape?.type === "point") {
      const flat = Array.isArray(shape?.list) ? shape.list.flat(3) : [];
      if (!flat || flat.length < 2 || !Number.isFinite(flat[0]) || !Number.isFinite(flat[1])) {
        return null;
      }
      const position = [flat[0], flat[1]];
      let color = isColor(shape?.mod2)
        ? shape?.mod2
        : defaultCouseMapElementColor[`${shape?.zone}`.toLowerCase()]
        ? defaultCouseMapElementColor[`${shape?.zone}`.toLowerCase()]
        : "grey";

      let iconCustom = getCustomMarker(
        shape,
        color
        // defaultZoneColor[`${shape?.zone}`]
      );
      return (
        <Marker
          customIdentifier={polygonOptions}
          position={position}
          icon={iconCustom}
          key={shape?.label + shape?.mod2}
          eventHandlers={{
            click: (clicked) => {
              if (!isMoveEnabled) {
                toggleEditMode(shape);
              }
            },
          }}
        />
      );
    }

    if (shape?.type === "line") {
      return (
        <Polyline
          customIdentifier={polygonOptions}
          color={
            isColor(shape?.mod2)
              ? shape?.mod2
              : defaultCouseMapElementColor[`${shape?.zone}`.toLowerCase()]
              ? defaultCouseMapElementColor[`${shape?.zone}`.toLowerCase()]
              : "grey"
          }
          positions={shape.list[0]}
          eventHandlers={{
            click: (event) => {
              // toggleEditMode(shape);
              if (!isMoveEnabled) {
                toggleEditMode(shape);
                // toggleEditMode(shape, event);
              } else {
                setMovableShapeData(shape);
              }
            },
          }}
          key={shape._id || shape.id}
        >
          {/* {_.isEmpty(editableArea) && ( //show tooltip only when not editing polygon */}
          <Tooltip sticky>
            {convertToLabelName(shape?.zone)}
            {shape?.zone === "Centralpath" && shape?.list?.[0]?.length > 1 && (() => {
              const coords = shape.list[0].map(([lat, lng]) => [lng, lat]);
              const line = turf.lineString(coords);
              const lengthYards = Math.round(turf.length(line, { units: "kilometers" }) * 1093.613);
              return <><br />{lengthYards} yards</>;
            })()}
            {shape?.Attributes?.Description !== undefined && shape?.Attributes?.Description !== 0 && (
              <><br />{convertToLabelWithAttributesDesc(shape)}</>
            )}
            {shape?.Attributes?.Type !== undefined && shape?.Attributes?.Type !== 0 && (
              <><br />{convertToLabelWithAttributesType(shape)}</>
            )}
            {shape?.Attributes?.Size !== undefined && shape?.Attributes?.Size !== 0 && (
              <><br />{convertToLabelWithAttributesSize(shape)}</>
            )}
          </Tooltip>
          {/* )} */}
        </Polyline>
      );
    }
  };

  const getHazardShape = (shape) => {
    try {
      let holeItem = visibleCourseElements[shape?.holeNumber - 1];

      let t = shape?.id?.split("_")[1];
      if (
        !_.isEmpty(shape) &&
        holeItem["Hazard"]?.idList?.includes(shape?.id) &&
        shape[`customLat${t}`] &&
        shape[`customLon${t}`]
      ) {
        let iconCustom = getCustomMarker(
          shape,
          defaultCouseMapElementColor.hazard
        );

        return (
          <Marker 
          opacity={compareCoordinates(markerLocation,[shape[`customLat${t}`], shape[`customLon${t}`]]) ? markerBlinkOpacity : 1}
            // customIdentifier={polygonOptions}
            position={[shape[`customLat${t}`], shape[`customLon${t}`]]}
            icon={iconCustom}
            key={shape[`customName${t}`] + shape?.holeNumber}
            eventHandlers={{
              click: (clicked) => {
                // toggleHazardEditMode({ ...shape, zone: "hazard" });
                // toggleEditMode(shape);
                if (!isMoveEnabled) {
                  toggleEditMode(shape);
                }
              },
            }}
          >
            {/* {_.isEmpty(editableArea) && ( //show tooltip only when not editing polygon */}
            <Tooltip sticky>{shape[`customName${t}`]}</Tooltip>
            {/* )} */}
          </Marker>
        );
      }
    } catch (error) {
    }
  };

  const getTeeCenterShape = (shape) => {
    try {
      let holeItem = visibleCourseElements[shape?.holeNumber - 1];

      let t = shape?.id?.split("_")[1];

      if (
        !_.isEmpty(shape) &&
        holeItem["Teeboxcenter"]?.idList?.includes(shape?.id) &&
        shape[`teeLat${t}`] &&
        shape[`teeLon${t}`]
      ) {
        let iconCustom = getCustomMarker(
          shape,
          defaultCouseMapElementColor.teeboxcenter
        );

        return (
          <Marker 
            opacity={compareCoordinates(markerLocation,[shape[`teeLat${t}`], shape[`teeLon${t}`]]) ? markerBlinkOpacity : 1}
            // customIdentifier={polygonOptions}
            position={[shape[`teeLat${t}`], shape[`teeLon${t}`]]}
            icon={iconCustom}
            key={"tee_" + shape?.holeNumber}
            eventHandlers={{
              click: (clicked) => {
                // toggleHazardEditMode({ ...shape, zone: "hazard" });
                // toggleEditMode(shape);
                if (!isMoveEnabled) {
                  toggleEditMode(shape);
                }
              },
            }}
          >
            {/* {_.isEmpty(editableArea) && ( //show tooltip only when not editing polygon */}
            <Tooltip sticky>{shape?.type}</Tooltip>
            {/* )} */}
          </Marker>
        );
      }
    } catch (error) {
    }
  };

  const getFCBShape = (shape) => {
    try {
      let holeItem = visibleCourseElements[shape?.holeNumber - 1];

      // let t = shape?.id?.split("_")[1];

      if (!_.isEmpty(shape) && holeItem["fcb"]?.idList?.includes(shape?.id)) {
        let iconCustom = getCustomMarker(
          shape,
          // defaultCouseMapElementColor.hazard
          defaultCouseMapElementColor[`${shape?.place}`]
        );
        return (
          <Marker
            // customIdentifier={polygonOptions}
            // position={[shape[`teeLat${t}`], shape[`teeLon${t}`]]}
            // position={shape?.shape}
            position={
              editMarkerData
                ? [editMarkerData?.lat, editMarkerData?.lng]
                : shape?.shape
            }
            opacity={compareCoordinates(markerLocation,shape?.shape) ? markerBlinkOpacity : 1}
            icon={iconCustom}
            key={shape?.place + shape?.holeNumber}
            eventHandlers={{
              click: (clicked) => {
                // toggleHazardEditMode({ ...shape, zone: "hazard" });
                // toggleEditMode(shape);
                if (!isMoveEnabled) {
                  toggleEditMode(shape);
                }
              },
            }}
          >
            {/* {_.isEmpty(editableArea) && ( //show tooltip only when not editing polygon */}
            <Tooltip sticky>{convertToLabelName(shape?.place)}</Tooltip>
            {/* )} */}
          </Marker>
        );
      }
    } catch (error) {
    }
  };

  const getFacilityShapeComponent = (shape) => {
    
    const polygonOptions = {
      shapetype: "map",
      // Add your custom key and value here
    };
    if (shape?.type === "polygon") {
        return (
          <Polygon
            customIdentifier={polygonOptions}
            color={
              isColor(shape?.mod2)
                ? shape?.mod2
                : defaultCouseMapElementColor[`${shape?.zone}`.toLowerCase()]
                ? defaultCouseMapElementColor[`${shape?.zone}`.toLowerCase()]
                : "grey"
            }
            positions={shape.list}
            pathOptions={{fill:false}} // added to disable full shape select
            eventHandlers={{
              click: (event) => {
                if (!isMoveEnabled) {
                  toggleEditMode(shape);
                } else {
                  setMovableShapeData(shape);
                }
  
                // if (shape?.label !== "Background") {
                // toggleEditMode(shape, event); //background edit has issue; need to check
                // }
              },
              mouseover: (event) => {
                const layer = event.target;
                layer.setStyle({ weight: 4 });
                // layer.bringToFront()
              },
              mouseout: (event) => {
  
                const layer = event.target;
  
                layer.setStyle({ weight: 3 });
                // layer.bringToBack();   // for layer select issue
              },
            }}
            fillColor={
              "transparent"
              // isColor(shape?.mod2)
              //   ? shape?.mod2
              //   : defaultZoneColor[`${shape?.zone}`]
              //   ? defaultZoneColor[`${shape?.zone}`]
              //   : "grey"
            }
            key={shape?.label + "_" + shape?.type}
  
            // keyname changes when color changes as color change does not trigger polygon re-render
          >
            {/* {_.isEmpty(editableArea) && ( //show tooltip only when not editing polygon */}
           
            {/* redmine */}
            {/* <Tooltip sticky>{convertToLabelName(shape?.zone)}</Tooltip> */}
            <Tooltip sticky>{convertToLabelName(holeElementsName(shape?.zone))}
              {shape?.Attributes?.Description !== undefined && shape?.Attributes?.Description !== 0 && (
                <><br />{convertToLabelWithAttributesDesc(shape)}</>
              )}
              {shape?.Attributes?.Type !== undefined && shape?.Attributes?.Type !== 0 && (
                <><br />{convertToLabelWithAttributesType(shape)}</>
              )}
              {shape?.Attributes?.Size !== undefined && shape?.Attributes?.Size !== 0 && (
                <><br />{convertToLabelWithAttributesSize(shape)}</>
              )}
            </Tooltip>
  
            {/* )} */}
          </Polygon>
        );
    }

    if (shape?.type === "point") {
      const flat = Array.isArray(shape?.list) ? shape.list.flat(3) : [];
      if (!flat || flat.length < 2 || !Number.isFinite(flat[0]) || !Number.isFinite(flat[1])) {
        return null;
      }
      const position = [flat[0], flat[1]];
      let color = isColor(shape?.mod2)
        ? shape?.mod2
        : defaultCouseMapElementColor[`${shape?.zone}`.toLowerCase()]
        ? defaultCouseMapElementColor[`${shape?.zone}`.toLowerCase()]
        : "grey";

      let iconCustom = getCustomMarker(
        shape,
        color
        // defaultZoneColor[`${shape?.zone}`]
      );
      return (
        <Marker
          customIdentifier={polygonOptions}
          position={position}
          icon={iconCustom}
          key={shape?.label + shape?.mod2}
          eventHandlers={{
            click: (clicked) => {
              // toggleEditMode(shape);
              if (!isMoveEnabled) {
                toggleEditMode(shape);
              }
            },
          }}
        >
<Tooltip sticky>{shape?.label}
   {shape?.Attributes?.Description && (
    <>
      <br />
      {convertToLabelWithAttributesDesc(shape)}
    </>
  )}
{shape?.Attributes?.Type && (
    <>
      <br />
      {convertToLabelWithAttributesType(shape)}
    </>
  )}
  {shape?.Attributes?.Size && (
    <>
      <br />
      {convertToLabelWithAttributesSize(shape)}
    </>
  )}
</Tooltip>
        </Marker>
      );
    }

    if (shape?.type === "line") {
      return (
        <Polyline
          customIdentifier={polygonOptions}
          color={
            isColor(shape?.mod2)
              ? shape?.mod2
              : defaultCouseMapElementColor[`${shape?.zone}`.toLowerCase()]
              ? defaultCouseMapElementColor[`${shape?.zone}`.toLowerCase()]
              : "grey"
          }
          positions={shape.list[0]}
          eventHandlers={{
            click: (event) => {
              if (!isMoveEnabled) {
                toggleEditMode(shape);
                // toggleEditMode(shape, event);
              } else {
                setMovableShapeData(shape);
              }
              // toggleEditMode(shape);
            },
          }}
          key={shape._id || shape.id}
        >
          {/* {_.isEmpty(editableArea) && ( //show tooltip only when not editing polygon */}
          <Tooltip sticky>
            {convertToLabelName(shape?.zone)}
            {shape?.zone === "Centralpath" && shape?.list?.[0]?.length > 1 && (() => {
              const coords = shape.list[0].map(([lat, lng]) => [lng, lat]);
              const line = turf.lineString(coords);
              const lengthYards = Math.round(turf.length(line, { units: "kilometers" }) * 1093.613);
              return <><br />{lengthYards} yards</>;
            })()}
            {shape?.Attributes?.Description !== undefined && shape?.Attributes?.Description !== 0 && (
              <><br />{convertToLabelWithAttributesDesc(shape)}</>
            )}
            {shape?.Attributes?.Type !== undefined && shape?.Attributes?.Type !== 0 && (
              <><br />{convertToLabelWithAttributesType(shape)}</>
            )}
            {shape?.Attributes?.Size !== undefined && shape?.Attributes?.Size !== 0 && (
              <><br />{convertToLabelWithAttributesSize(shape)}</>
            )}
          </Tooltip>
          {/* )} */}
        </Polyline>
      );
    }
  };

  const getClubHouseCenterMarker = (shape) => {
    if (shape?.clubLat && shape?.clubLon)
      return (
        <Marker
          position={[shape.clubLat, shape.clubLon]}
          icon={L.divIcon({
          className: "custom-marker2",
          html: `<div class="dialog_icon2" style="background-color:#821EC6;text-shadow:1px 1px 1px #000, -1px -1px 0 #000, 1px -1px 0 #000, -1px 1px 0 #000;">
            CH
            <span style="background-color:#821EC6"></span>
            </div>`,
          })}
          eventHandlers={{
            click: () => {
              // toggleEditMode(shape);
              if (!isMoveEnabled) {
                toggleEditMode(shape);
              }
            },
          }}
        />
      );
  };

  const removeSelectedLayer = useCallback(
    (layer) => {
      featureGroupRef.current?.removeLayer(layer);
    },
    [featureGroupRef]
  );

  const resetDrawingMode = useCallback(() => {
    eventEmitter.emit(events.addMarkerToggle, { visible: false });
    eventEmitter.emit(events.disableDraw);
    drawingLayerRef.current = null;

    if (!_.isEmpty(addedLayer)) {
      addedLayer?.forEach((layer) => {
        removeSelectedLayer(layer); //removing previously added layer
      });
    }
    setAddedPoints([]);
    setAutoGenPreview(null);
    autoGenExistingBgRef.current = null;
    setDistanceGuide(null);
    distanceGuideActiveRef.current = false;
  }, [addedLayer]);

  if (mapRef.current) {
    mapRef.current.on("click", (e) => {
      if (!_.isEmpty(editableAreaRef.current)) {
        // open popup
        eventEmitter.emit(events.addMarkerToggle, { visible: true });
      }
    });
  }

  const drawStart = (drawEvent) => {};

  const cleartempShapeAnddisableDraw = () => {
    disableDraw();
    drawingLayerRef.current = null;
  };

  const deleteCourseVectorElement = ({ idList, type }) => {
    if (!_.isEmpty(idList)) {
      if (type === "facility") {
        idList.forEach((id) => {
          let holeItem = courseWiseData.find((s) => s._id === id);
          if (holeItem?.label === "Centralpath") {
            setCentralPathLine(undefined); // prevent auto re-add on subsequent updates
          }
          let payload = {
            id_courseGPSVector: holeItem?._id,
            active: 0, // 0 means delete
          };
          updateCourseGPSVectorMap(payload);
        });
      } else {
        idList.forEach((id) => {
          let holeItem = holeWiseData.find((s) => s._id === id);
          let payload = {
            id_courseGPSVector: holeItem?._id,
            active: 0, // 0 means delete
          };
          updateCourseGPSVectorMap(payload);
        });
      }
    }
    // let holeItem = holeWiseData.find((s) => s._id === id);
    // let payload = {
    //   id_courseGPSVector: holeItem?._id,
    //   active: 0, // 0 means delete
    // };
    // updateCourseGPSVectorMap(payload);
  };
  const deleteCourseSimpleElement = ({ data, custLat, custLon }) => {
    let payload = {
      id_course: parseInt(id_courseFromQuery),
      clubLat: custLat ? Number(custLat) : courseGPSMapping?.clubLat,
      clubLon: custLon ? Number(custLon) : courseGPSMapping?.clubLon,
      GPSList: data,
    };

    updateCourseMappingGPSData(payload);
  };

  const resetMoveMode = () => {
    if (isMoveEnabled) {
      setMovableShapeData(null);
    }
  };
  useEscKeyPress(() => {
    if (fullCourseShift.activeRef.current) {
      eventEmitter.emit(events.escapeFullCourseShift);
      return;
    }
    if (isSelectionDeleteEnabledRef.current) {
      exitSelectionDeleteMode();
    }
    setIsScaleDrawEnabled(false);
    eventEmitter.emit(events.resetDrawingMode);
    eventEmitter.emit("resetMoveMode");
  });

  const triggerEditMode = ({shape_id}) => {};
  
  useEventEmitter(events.triggerEditModeExternal, triggerEditMode);
  useEventEmitter("resetMoveMode", resetMoveMode);
  useEventEmitter(events.savePolygon, saveEditedChanges);
  useEventEmitter(events.addNewShape, saveNewShape);
  useEventEmitter(events.autoGenerateBackground, handleAutoGenerateBackground);
  const enterFullCourseShift = () => {
    if (isSelectionDeleteEnabledRef.current) {
      exitSelectionDeleteMode();
    }
    eventEmitter.emit(events.resetDrawingMode);
    eventEmitter.emit("resetMoveMode");
    imageOverlayTool.stopEdit();
    fullCourseShift.enter();
  };
  useEventEmitter(events.openFullCourseShift, enterFullCourseShift);
  const shiftSettleBaselineRef = useRef(null);
  useEffect(() => {
    if (fullCourseShift.phase !== "settling") {
      shiftSettleBaselineRef.current = null;
      if (
        shiftReloadPendingRef.current &&
        fullCourseShift.phase !== "processing"
      ) {
        shiftReloadPendingRef.current = false;
        LoadShapeData();
      }
      return;
    }
    const snapshot = {
      courseWiseData,
      holeWiseData,
      hazardData,
      fcbData,
      teeCenterData,
    };
    const baseline = shiftSettleBaselineRef.current;
    if (!baseline) {
      shiftSettleBaselineRef.current = snapshot;
      if (shiftReloadPendingRef.current) {
        shiftReloadPendingRef.current = false;
        LoadShapeData();
      }
      return;
    }
    const changed = Object.keys(snapshot).some(
      (key) => snapshot[key] !== baseline[key]
    );
    if (changed) {
      shiftSettleBaselineRef.current = null;
      flushSync(() => {
        fullCourseShift.completeSettling();
      });
    }
  }, [
    fullCourseShift.phase,
    courseWiseData,
    holeWiseData,
    hazardData,
    fcbData,
    teeCenterData,
  ]);
  useEventEmitter(events.draw, filterDrawActions);
  useEventEmitter(events.disableDraw, cleartempShapeAnddisableDraw);
  useEventEmitter(events.resetDrawingMode, cancelEdit);
  useEventEmitter(
    events.deleteCourseMapElement.courseMapVectorDelete,
    deleteCourseVectorElement
  );
  useEventEmitter(
    events.deleteCourseMapElement.courseMapSimpleDataDelete,
    deleteCourseSimpleElement
  );

  useEventEmitter(events.fitMapToHole, (e) => {
    if (!mapRef.current) return
    const force = !!e.force;

    const holeNumber = Number(e.holeNumber);
    const coords = [];

    const vis = visibleCourseElements?.[holeNumber - 1] || {};
    
    const willRender =
      (vis.Teebox?.idList?.length > 0 && vis.Teebox?.idList[0]) ||
      (vis.Fairway?.idList?.length > 0 && vis.Fairway?.idList[0]) ||
      (vis.Green?.idList?.length > 0 && vis.Green?.idList[0]) ||
      (vis.Bunker?.idList?.length > 0 && vis.Bunker?.idList[0]) ||
      (vis.Hazard?.idList?.length > 0 && vis.Hazard?.idList[0]) ||
      (vis.Teeboxcenter?.idList?.length > 0 && vis.Teeboxcenter?.idList[0]) ||
      (vis.fcb?.idList?.length > 0 && vis.fcb?.idList[0]) ||
      (vis.Greencenter?.idList?.length > 0 && vis.Greencenter?.idList[0]) ||
      (vis.Perimeter?.idList?.length > 0 && vis.Perimeter?.idList[0]) ||
      (vis.Centralpath?.idList?.length > 0 && vis.Centralpath?.idList[0]);
    
    if (!willRender && !force) {
      return;
    }

    // --- collect coords from hole geometry ---
    const holeElements = (holeWiseData || []).filter(it => it.hole === holeNumber);
    holeElements.forEach(el => {
      if (el.type === "polygon" || el.type === "line") {
        const flattened = Array.isArray(el.list) ? el.list.flat(3) : [];
        pushMany(coords, flattened); // will be validated via toTuple below
      } else if (el.type === "point") {
        const flattened = Array.isArray(el.list) ? el.list.flat(3) : [];
        if (flattened.length >= 2) coords.push([flattened[0], flattened[1]]);
      }
    });

    // --- hazards ---
    const hazards = (hazardData && hazardData[holeNumber - 1]) || [];
    hazards.forEach(h => {
      const idx = Number(h.id?.split("_")[1]);
      coords.push([h[`customLat${idx}`], h[`customLon${idx}`]]);
    });

    // --- tee centers ---
    const teeCenters = (teeCenterData && teeCenterData[holeNumber - 1]) || [];
    teeCenters.forEach(tee => {
      const idx = Number(tee.id?.split("_")[1]);
      coords.push([tee[`teeLat${idx}`], tee[`teeLon${idx}`]]);
    });

    // --- F/C/B ---
    const fcbs = (fcbData && fcbData[holeNumber - 1]) || [];
    fcbs.forEach(fcb => coords.push(fcb?.shape));

    // --- validate using toTuple; filter out junk & (0,0) ---
    const valid = coords
      .map(toTuple)
      .filter(t =>
        Array.isArray(t) &&
        t.length === 2 &&
        Number.isFinite(+t[0]) &&
        Number.isFinite(+t[1]) &&
        t[0] >= -90 && t[0] <= 90 &&
        t[1] >= -180 && t[1] <= 180 &&
        !(+t[0] === 0 && +t[1] === 0)
      );
    
    if (valid.length === 0) {
      return;
    }

    if (valid.length === 1) {
      const [lat, lng] = valid[0];
      const hash = `pt:${lat.toFixed(6)},${lng.toFixed(6)}`;
      if (lastFitRef.current.hole === holeNumber && lastFitRef.current.hash === hash) return;

      lastFitRef.current = { hole: holeNumber, hash };
      const targetZoom = Math.min(19, mapRef.current.getMaxZoom?.() ?? 19);
      mapRef.current.invalidateSize(true);
      mapRef.current.flyTo([lat, lng], targetZoom, { animate: true, duration: 0.8 });
      return;
    }

    const bounds = L.latLngBounds(valid.map(([lat, lng]) => L.latLng(+lat, +lng)));
    if (!bounds.isValid()) return;

    const sw = bounds.getSouthWest();
    const ne = bounds.getNorthEast();
    const hash = `${sw.lat.toFixed(6)},${sw.lng.toFixed(6)}:${ne.lat.toFixed(6)},${ne.lng.toFixed(6)}`;

    if (!force && lastFitRef.current.hole === holeNumber && lastFitRef.current.hash === hash) return;

    lastFitRef.current = { hole: holeNumber, hash };

    requestAnimationFrame(() => {
      mapRef.current.invalidateSize(true);
      mapRef.current.fitBounds(bounds, {
        paddingTopLeft: [60, 60],
        paddingBottomRight: [60, 60],
        animate: true,
        duration: 0.8,
      });
    })
  });

  useEventEmitter(events.zoomMapToCoordinate, (e) => {
    flyTo(e.coordinate, e.zoom || 19, 0.8);
  });

  const handleZoom = (event) => {
    if (event.deltaY > 0) {
      zoomOut();
    } else {
      zoomIn();
    }
  };
  React.useEffect(() => {
    if (mapDomEl) {
      mapDomEl.addEventListener("wheel", handleZoom);
      return () => {
        mapDomEl.removeEventListener("wheel", handleZoom);
      };
    }
  }, [mapDomEl, isGoogleView]);

  // Force Leaflet to re-measure the container after mount. Without this the
  // map's tile pane stays grey on initial load because the container has
  // wrong/zero dimensions while the surrounding layout (SideBar / MapWrapper)
  // is still settling — Leaflet caches the bad size and never re-fetches
  // tiles. The fitBounds/flyTo handlers (clicked from hole/facility tabs)
  // already call invalidateSize, which is why those clicks unstick the tiles.
  // We need the same call to fire even when no auto-fit runs on mount
  // (e.g. courses with no Background, where currentLocation sets a center
  // via setView and bypasses fitBounds).
  React.useEffect(() => {
    if (!mapDomEl) return;
    const initialFix = setTimeout(() => {
      mapRef.current?.invalidateSize(true);
    }, 150);
    const ro = typeof ResizeObserver !== "undefined"
      ? new ResizeObserver(() => mapRef.current?.invalidateSize(true))
      : null;
    ro?.observe(mapDomEl);
    return () => {
      clearTimeout(initialFix);
      ro?.disconnect();
    };
  }, [mapDomEl]);

  const getMovedShapeData = (data) => {
    setMovableShapeData(data);
  };

  useMovableMapElement(
    movableShapeData,
    getMovedShapeData,
    courseWiseData,
    holeWiseData
  );

  const getMovableShapeComponent = (data) => {
    if (data?.type === "polygon") {
      return (
        <Polygon
          dashArray={SCALE_DASH}
          pathOptions={{ color: "purple", fillColor: "violet" }}
          positions={movableShapeData?.list[0]}
          // edit
        >
          <Tooltip sticky>
            Press Esc to discard changes. Press Enter Key to save changes
          </Tooltip>
        </Polygon>
      );
    }

    if (data?.type === "line") {
      return (
        <Polyline
          color={"purple"}
          dashArray={SCALE_DASH}
          positions={movableShapeData?.list[0]}
          key={`scale_move_${Math.random()}`}
        >
          <Tooltip sticky>
            Press Esc to discard changes. Press Enter Key to save changes
          </Tooltip>
        </Polyline>
      );
    }
  };
  
  // Distance guide: activate when drawing/editing Background
  useEffect(() => {
    const isDrawingBackground =
      isDrawing && selectedZoneType?.element === "Background";
    const isEditingBackground =
      editableArea && editableArea?.label === "Background";

    distanceGuideActiveRef.current = isDrawingBackground || isEditingBackground;

    if (!distanceGuideActiveRef.current) {
      setDistanceGuide(null);
    }

    const mapEl = document.getElementById("GoogleMap");
    if (!mapEl) return;

    if (distanceGuideActiveRef.current) {
      mapEl.classList.add("distance-guide-active");

      // Directly hide any existing draw tooltips while adding Background element.
      const hideTooltips = () => {
        mapEl.querySelectorAll('.leaflet-draw-tooltip').forEach(el => {
          el.style.setProperty('display', 'none', 'important');
        });
      };
      hideTooltips();

      const observer = new MutationObserver(hideTooltips);
      observer.observe(mapEl, { childList: true, subtree: true });

      return () => observer.disconnect();
    } else {
      mapEl.classList.remove("distance-guide-active");
      mapEl.querySelectorAll('.leaflet-draw-tooltip').forEach(el => {
        el.style.removeProperty('display');
      });
    }
  }, [isDrawing, selectedZoneType, editableArea]);

  useEffect(() => {
    const map = mapRef.current;
    if (!map) return;

    let debounceTimer = null;
    const handleMouseMove = (e) => {
      if (!distanceGuideActiveRef.current) return;
      if (debounceTimer) clearTimeout(debounceTimer);
      debounceTimer = setTimeout(() => {
        const result = findNearestDistanceToPerimeters(
          e.latlng,
          holeWiseDataRef.current
        );
        if (result) {
          setDistanceGuide({
            cursorPos: [e.latlng.lat, e.latlng.lng],
            nearestPos: result.nearestPoint,
            distance: result.distance,
          });
        } else {
          setDistanceGuide(null);
        }
      }, 50);
    };

    map.on("mousemove", handleMouseMove);
    return () => {
      map.off("mousemove", handleMouseMove);
      if (debounceTimer) clearTimeout(debounceTimer);
    };
  }, [mapDomEl]);

  const getDistanceGuideColor = (distance) => {
    if (distance >= 190 && distance <= 210) return "#4CAF50";
    if (distance >= 150 && distance <= 250) return "#FF9800";
    return "#F44336";
  };

  const selectionTotal = selectionCandidates
    ? selectionCandidates.vectorShapes.length +
      selectionCandidates.teeCenters.length
    : 0;

  return (
    <div id="DraggableContainer">
      {(currentLocation || (boundLatLng && !_.isEmpty(boundLatLng))) && (
        <MapContainer
          bounds={!_.isEmpty(boundLatLng) ? boundLatLng : undefined}
          center={!_.isEmpty(boundLatLng) ? undefined : currentLocation}
          zoom={19}
          scrollWheelZoom={true}
          ref={mapRef}
          maxZoom={isGoogleView ? 22 : 19}
          minZoom={MIN_ZOOM}
          style={{ height: "100vh" }}
          zoomControl={false}
          id="GoogleMap"
          className=""
          doubleClickZoom={false}
        >
          {(() => {
            const MapClickHandler = () => {
              useMapEvents({
                dblclick(e) {
                  const { lat, lng } = e.latlng;
                  window.open(`https://www.google.com/maps?q=${lat},${lng}`, "_blank");
                },
              });
              return null;
            };
            return <MapClickHandler />;
          })()}
            <FeatureGroup>
            {courseWiseData?.map((shape, index) => {
              return (
                <>
                  <React.Fragment key={shape._id || shape.id}>
                    {editableArea?._id !== shape?._id && (
                      <>
                        {getActiveFacilityFeatureIcon(shape) &&
                          getFacilityShapeComponent(shape)}
                      </>
                    )}
                  </React.Fragment>
                </>
              );
            })}

            {holeWiseData.length &&
              holeWiseData.map((shape, index) => {
                return (
                  <>
                    {editableArea?._id !== shape?._id && (
                      <>
                        {getActiveViewIcon(shape) && getShapeComponent(shape)}
                      </>
                    )}
                  </>
                );
              })}
            {fcbData?.map((shapeList, hole) => {
              return (
                <>
                  {visibleCourseElements[hole] &&
                    visibleCourseElements[hole]["fcb"]?.isElementVisible &&
                    shapeList?.map((shape, index) => {
                      // return <>{getHazardShape(shape)}</>;
                      return (
                        <>
                          {editableArea?.id !== shape?.id && (
                            <>{getFCBShape(shape)}</>
                          )}
                        </>
                      );
                    })}
                </>
              );
            })}

            {hazardData?.map((shapeList, hole) => {
              return (
                <>
                  {visibleCourseElements[hole] &&
                    visibleCourseElements[hole]["Hazard"]?.isElementVisible &&
                    shapeList?.map((shape, index) => {
                      // return <>{getHazardShape(shape)}</>;
                      return (
                        <>
                          {editableArea?.id !== shape?.id && (
                            <>{getHazardShape(shape)}</>
                          )}
                        </>
                      );
                    })}
                </>
              );
            })}

            {teeCenterData?.map((shapeList, hole) => {
              return (
                <>
                  {visibleCourseElements[hole] &&
                    visibleCourseElements[hole]["Teeboxcenter"]
                      ?.isElementVisible &&
                    shapeList?.map((shape, index) => {
                      return (
                        <>
                          {editableArea?.id !== shape?.id && (
                            <>{getTeeCenterShape(shape)}</>
                          )}
                        </>
                      );
                    })}
                </>
              );
            })}
            {!_.isEmpty(clubHouseCenterData) && (
              <>
                {editableArea?.id !== clubHouseCenterData?.id && (
                  <>{getClubHouseCenterMarker(clubHouseCenterData)}</>
                )}
              </>
            )}

            {autoGenPreview && (
              <Polygon
                positions={autoGenPreview}
                pathOptions={{
                  color: "#F91E00",
                  weight: 2,
                  dashArray: "10 5",
                  fillOpacity: 0.1,
                  fillColor: "#F91E00",
                }}
                key="auto_gen_preview"
              />
            )}

            {distanceGuide && (
              <>
                <Polyline
                  positions={[distanceGuide.cursorPos, distanceGuide.nearestPos]}
                  pathOptions={{
                    color: getDistanceGuideColor(distanceGuide.distance),
                    weight: 2,
                    dashArray: "5 5",
                  }}
                  key="distance_guide_line"
                />
                <Marker
                  position={distanceGuide.cursorPos}
                  icon={L.divIcon({
                    className: "distance-guide-label",
                    html: `<span style="background:rgba(0,0,0,0.7);color:#fff;padding:2px 6px;border-radius:3px;font-size:12px;white-space:nowrap;">${Math.round(distanceGuide.distance)}m</span>`,
                    iconAnchor: [-10, 20],
                  })}
                  key="distance_guide_marker"
                  interactive={false}
                />
              </>
            )}

            {scaleLineData?.length > 0 && (
              <Polyline
                customIdentifier={{ shapetype: "scale" }}
                color={"red"}
                dashArray={SCALE_DASH}
                positions={scaleLineData}
                eventHandlers={{
                  dblclick: (clicked) => {
                    setScaleLineData([]);
                  },
                }}
                key={`scale_${Math.random()}`}
              >
                <Tooltip sticky>Double click to remove</Tooltip>
              </Polyline>
            )}
          </FeatureGroup>

          {selectionCandidates && (
            <SelectionHighlightLayer
              vectorShapes={selectionCandidates.vectorShapes}
              teeCenters={selectionCandidates.teeCenters}
            />
          )}

          <FeatureGroup ref={featureGroupRef}>
            <EditControl
              ref={editControlRef}
              onMounted={_onMounted}
              onCreated={_onCreated}
              onEdited={(e) => {
                _onEdited(e);
              }}
              edit={EDIT_CONTROL_EDIT_OPTIONS}
              draw={EDIT_CONTROL_DRAW_OPTIONS}
      onDrawStart={(e) => {

    setTimeout(() => {
      const drawControl = editControlRef.current;

      const handler = drawControl?._toolbars?.draw?._activeMode?.handler;

      if (handler?._poly) {
        drawingLayerRef.current = handler._poly;
      }
    }, 0);
  }}
            />

            {courseWiseData?.map((shape, index) => {
              return (
                <>
                  <React.Fragment key={shape._id || shape.id}>
                    {editableArea?._id === shape?._id && (
                      <>
                        {getActiveFacilityFeatureIcon(shape) &&
                          getFacilityShapeComponent(shape)}
                      </>
                    )}
                  </React.Fragment>
                </>
              );
            })}
            {holeWiseData.length &&
              holeWiseData.map((shape, index) => {
                return (
                  <>
                    <>
                      {editableArea?._id === shape?._id && (
                        <>
                          {getActiveViewIcon(shape) && getShapeComponent(shape)}
                        </>
                      )}
                    </>
                  </>
                );
              })}

            {teeCenterData?.map((shapeList, hole) => {
              return (
                <>
                  {visibleCourseElements[hole] &&
                    visibleCourseElements[hole]["Teeboxcenter"]
                      ?.isElementVisible &&
                    shapeList?.map((shape, index) => {
                      return (
                        <>
                          {editableArea?.id === shape?.id && (
                            <>{getTeeCenterShape(shape)}</>
                          )}
                        </>
                      );
                    })}
                </>
              );
            })}
            {hazardData?.map((shapeList, hole) => {
              return (
                <>
                  {visibleCourseElements[hole] &&
                    visibleCourseElements[hole]["Hazard"]?.isElementVisible &&
                    shapeList?.map((shape, index) => {
                      return (
                        <>
                          {editableArea?.id === shape?.id && (
                            <>{getHazardShape(shape)}</>
                          )}
                        </>
                      );
                    })}
                </>
              );
            })}

            {fcbData?.map((shapeList, hole) => {
              return (
                <>
                  {visibleCourseElements[hole] &&
                    visibleCourseElements[hole]["fcb"]?.isElementVisible &&
                    shapeList?.map((shape, index) => {
                      return (
                        <>
                          {editableArea?.id === shape?.id && (
                            <>{getFCBShape(shape)}</>
                          )}
                        </>
                      );
                    })}
                </>
              );
            })}

            {!_.isEmpty(clubHouseCenterData) && (
              <>
                {editableArea?.id === clubHouseCenterData?.id && (
                  <>
                    {getActiveFacilityFeatureIcon(clubHouseCenterData) &&
                      getClubHouseCenterMarker(clubHouseCenterData)}
                  </>
                )}
              </>
            )}
            {movableShapeData && getMovableShapeComponent(movableShapeData)}
          </FeatureGroup>

          <ImageOverlayLayer
            overlays={imageOverlayTool.overlays}
            editingId={imageOverlayTool.editingId}
            setOverlayBounds={imageOverlayTool.setOverlayBounds}
            setOverlayRotation={imageOverlayTool.setOverlayRotation}
          />
          <CourseShiftLayer
            phase={fullCourseShift.phase}
            delta={fullCourseShift.delta}
            setDelta={fullCourseShift.setDelta}
          />

          {!isGoogleView ? (
              <>
                <TileLayer
                  url={`https://atlas.microsoft.com/map/tile?api-version=2.1&tilesetId=microsoft.imagery&zoom={z}&x={x}&y={y}&subscription-key=${AzureMapAPIKey}`}                  
                  attribution="© Microsoft Azure Maps"
                  maxNativeZoom={22}
                  maxZoom={22}
                  minNativeZoom={0}
                  eventHandlers={{
                    tileload: () => setTileError(false), 
                    tileerror: (e) => {
                    console.error('Tile error details:', {
                      coords: e.coords,
                      url: e.tile.src,
                      error: e.error
                    });
                    setTileError(true);
                    },
                  }}
                />
                <TileLayer
                  url={`https://atlas.microsoft.com/map/tile?api-version=2.1&tilesetId=microsoft.base.hybrid.road&zoom={z}&x={x}&y={y}&subscription-key=${AzureMapAPIKey}`}                  
                  attribution="© Microsoft Azure Maps"
                  maxNativeZoom={22}
                  maxZoom={22}
                  minNativeZoom={0}
                  eventHandlers={{
                    tileload: () => setTileError(false), 
                    tileerror: (e) => {
                    console.error('Tile error details:', {
                      coords: e.coords,
                      url: e.tile.src,
                      error: e.error
                    });
                    setTileError(true);
                    },
                  }}
                />
                  {tileError && <AzureStaticOverlay />}
              </>
            ) : (
              <ReactLeafletGoogleLayer
                type="hybrid"
                maxZoom={MAX_ZOOM}
                minZoom={MIN_ZOOM}
                apiKey={GoogleMapAPIKey}
              />
            )}
        </MapContainer>
      )}

      <ModalWrapper
        open={!!selectionCandidates}
        onClose={cancelSelectionDelete}
        handleClose={cancelSelectionDelete}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <NoificationModal
          label="Delete Selected Objects"
          backgroundColor={modalProperties.info.backgroundColor}
          image={modalProperties.warning.icon}
          title={`<span style='font-size:14px'>Are you sure you want to delete<br/> ${selectionTotal} map object${selectionTotal === 1 ? "" : "s"}?</span>`}
          rejCallBack={cancelSelectionDelete}
          affrCallBack={confirmSelectionDelete}
          affrBtnTxt={"Continue"}
          rejBtnTxt={"Cancel"}
        />
      </ModalWrapper>

      <MapControlList
        BasicControls={BasicControls}
        cancelEdit={cancelEdit}
        fcbData={fcbData}
        hazardData={hazardData}
        mapControlList={mapControlList}
        teeCenterData={teeCenterData}
        courseWiseData={courseWiseData}
        clubHouseCenterData={clubHouseCenterData}
        isMapControlListPanelHidden={isMapControlListPanelHidden}
        setMapControlListPanelHidden={setMapControlListPanelHidden}
      />

      {mapControlList?.map((control, index) => {
        return (
          <DraggableCoursePopOver
            setMapControlListPanelHidden={setMapControlListPanelHidden}
            title={control?.title}
            data={control?.data}
            cancelEdit={cancelEdit}
            hazardData={hazardData}
            fcbData={fcbData}
            teeCenterData={teeCenterData}
            courseWiseData={courseWiseData}
            clubHouseCenterData={clubHouseCenterData}
          />
        );
      })}
      <CustomCoursePopOver
        title={
          getPopUpTitle(editableArea, selectedZoneType)
        }
      />
      <ImageOverlayPanel
        overlays={imageOverlayTool.overlays}
        editingId={imageOverlayTool.editingId}
        addImages={imageOverlayTool.addImages}
        removeOverlay={imageOverlayTool.removeOverlay}
        toggleVisible={imageOverlayTool.toggleVisible}
        setOverlayOpacity={imageOverlayTool.setOverlayOpacity}
        startEdit={imageOverlayTool.startEdit}
        stopEdit={imageOverlayTool.stopEdit}
      />
      <ToolsMenu layoutHoles={courseMapData?.LayoutHoles} />
      <CourseShiftPanel shift={fullCourseShift} mapRef={mapRef} />
      <CourseMapInfoPopOver courseID={id_courseFromQuery} />
      <CourseScoreCardPopOver />
      <CourseMappingNoteList />
    </div>
  );
};
export default React.memo(CourseMap);
